/**
 * 本地开发调试模型数据定义
 */
import * as local_urls from '../constants/constants_url';
const urls = global && global.constants && global.constants.urls ? global.constants.urls : local_urls;
export const appDevModels = () => [
  {
    businessName: 'organization',
    modelType: 'entity',
    action: {
      import: {
        api: urls.kUrlImportOrganization,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      getOrganizationInfo: {
        api: urls.kUrlgetOrganizationInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      orgSelect: {
        api: urls.kUrlOrgSelect,
        methodType: 'POST',
        params: [],
        returnField: {}
      },

      export: {
        api: urls.kUrlOrganizationExport,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByPage: {
        api: urls.kUrlOrganizationListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByNotFilterPage: {
        api: urls.kUrlOrganizationListByNoFilterPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      pageListByCond: {
        api: urls.kUrlOrganizationPageListByCond,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getNodeTreeData: {
        api: urls.kUrlOrganizationTreeData,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      addOrganization: {
        api: urls.kUrlAddOrganization,
        methodType: 'POST',
        params: ['name', 'code', 'organizationNodeCategory', 'state'],
        returnField: {},
      },
      updateOrganization: {
        api: urls.kUrlUpdateOrganization,
        methodType: 'PUT',
        params: ['id', 'name', 'code', 'organizationNodeCategory', 'state'],
        returnField: {},
      },
      deleteOrganization: {
        api: urls.kUrlDeleteOrganization,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      enableOrganization: {
        api: urls.kUrlEnableOrganization,
        methodType: 'PUT',
        params: ['ids', 'state'],
        returnField: {},
      },
      getOrganizationPageByUser: {
        api: urls.kUrlOrganizationByUser,
        methodType: 'GET',
        params: [],
        returnField: {}
      }
    },
    initData: {}
  },
  {
    businessName: 'orgAuthority',
    modelType: 'entity',
    action: {
      getOrgAuthorityInfo: {
        api: urls.kUrlGetOrgAuthorityInfo,
        methodType: 'GET',
        returnField: {},
        params: ['managerType']
      },
      createOrgAuthority: {
        api: urls.kUrlCreateOrgAuthority,
        methodType: 'POST',
        params: ['managerType', 'state'],
        returnField: {},
      },
      enableOrgAuthority: {
        api: urls.kUrlEnableOrgAuthority,
        methodType: 'PUT',
        params: ['ids', 'state', 'managerType'],
        returnField: {},
      },
      deleteOrgAuthority: {
        api: urls.kUrlDeleteOrgAuthority,
        methodType: 'DELETE',
        params: ['ids', 'managerType'],
        returnField: {},
      },
    },
    initData: { data: {} }
  },
  {
    businessName: 'personInfo',
    modelType: 'entity',
    action: {
      personSelect: {
        api: urls.kUrlPersonSelect,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      getPersonData: {
        api: urls.kUrlPersonAndUserIdentitiesInfo,
        methodType: 'GET',
        returnField: {},
        params: ['personId']
      },
      getPersonAndUserInfo: {
        api: urls.kUrlPersonAndUserInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPersonAndUserInfoFilter: {
        api: urls.kUrlPersonAndUserInfoFilter,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      personAndUserInfoList: {
        api: urls.kUrlPersonAndUserInfoList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      listByPage: {
        api: urls.kUrlListByPageForAbility,
        methodType: 'GET',
        returnField: {},
        params: []
      },

      findIdentities: {
        api: urls.kUrlFindIdentities,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: { data: {} }
  },
  {
    businessName: 'userManagement',
    modelType: 'entity',
    action: {
      userList: {
        api: urls.kUrlUserListByPage,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      getUserListByGroupPlugPage: {
        api: urls.kUrlUserListByGroupPlugPage,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      addUser: {
        api: urls.kUrlAddUser,
        methodType: 'POST',
        params: ['userName', 'fullName'],
        returnField: {},
      },
      updateUser: {
        api: urls.kUrlUpdateUser,
        methodType: 'PUT',
        params: ['id', 'userName', 'fullName'],
        returnField: {},
      },
      deleteUser: {
        api: urls.kUrlDeleteUser,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      updateUserDisabled: {
        api: urls.kUrlUpdateUserDisabled,
        methodType: 'PUT',
        params: ['personId', 'disabled'],
        returnField: {},
      },
      userResetPassword: {
        api: urls.kUrlUpdateUserResetPassword,
        methodType: 'PUT',
        params: ['ids'],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'userIdentityManagement',
    modelType: 'entity',
    action: {
      getUserIdentityDetailPage: {
        api: urls.kUrlQueryUserIdentityDetailPage,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      queryUserIdentityInfoList: {
        methodType: 'GET',
        api: urls.kUrlQueryUserIdentityInfoList,
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'testLogin',
    modelType: 'entity',
    action: {
      doLogin: {
        api: urls.kUrlNewServer,
        methodType: 'GET',
        params: ['name'],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'personPathReport',
    modelType: 'entity',
    action: {
      getPersonPathReport: {
        api: urls.kUrlPersonPathReport,
        methodType: 'POST',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'organizationNodeCategoryx',
    modelType: 'entity',
    action: {
      getTypeNodeList: {
        api: urls.kUrlTypeNodeList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'organizationNodeCategory',
    modelType: 'entity',
    action: {
      getTypeNodeList: {
        api: urls.kUrlTypeNodeList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getListByPage: {
        api: urls.kUrlListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      getParentNameList: {
        api: urls.kUrlGetParentNameList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlOrganizationNodeCategoryAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlOrganizationNodeCategoryUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlOrganizationNodeCategoryDelete,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      enable: {
        api: urls.kUrlOrganizationNodeCategoryEnable,
        methodType: 'PUT',
        returnField: {},
        params: ['ids'],
      },
    },
    initData: {}
  },
  {
    businessName: 'elements',
    modelType: 'entity',
    action: {
      getElementsListByPage: {
        api: urls.kUrlElementsListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      addElements: {
        api: urls.kUrlAddElements,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      deleteElements: {
        api: urls.kUrlDeleteElements,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      updateElements: {
        api: urls.kUrlUpdateElements,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      setElements: {
        api: urls.kUrlSetElements,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      listByCondition: {
        api: urls.kUrlListByCondition,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getElementsByMenuId: {
        api: urls.kUrlGetElementsByMenuId,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlExportElements,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: { data: [] }
  }, {
    businessName: 'role',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlRoleListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getListByCondition: {
        api: urls.kUrlRoleListByCondition,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddRole,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdateRole,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlDeleteRole,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      export: {
        api: urls.kUrlExportRoles,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  }, {
    businessName: 'roleUser',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlRoleUserListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getListByCondition: {
        api: urls.kUrlRoleUserListByCondition,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddRoleUser,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      addUsersForRole: {
        api: urls.kUrlAddUsersForRoleRoleUser,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      addUsersForRoleByUserName: {
        api: urls.kUrlAddUsersForRoleByUserNameRoleUser,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateOrSave: {
        api: urls.kUrlUpdateOrSaveRoleUser,
        methodType: 'PUT',
        returnField: {},
        params: ['personId', 'roleIds'],
      },
      update: {
        api: urls.kUrlUpdateRoleUser,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlDeleteRoleUser,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      getPersonIdsByRoleIds: {
        api: urls.kUrlGetPersonIdsByRoleIds,
        methodType: 'GET',
        returnField: {},
        params: ['roleIds']
      },
      import: {
        api: urls.kUrlImportRoleUser,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
    },
    initData: {}
  },
  {
    businessName: 'roleGroup',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlRoleGroupListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getListByCondition: {
        api: urls.kUrlRoleGroupListByCondition,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddRoleGroup,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      addGroupsForRole: {
        api: urls.kUrlAddGroupsForRoleRoleGroup,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateOrSave: {
        api: urls.kUrlUpdateOrSaveRoleGroup,
        methodType: 'PUT',
        returnField: {},
        params: ['personId', 'roleIds'],
      },
      update: {
        api: urls.kUrlUpdateRoleGroup,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlDeleteRoleGroup,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
    },
    initData: {}
  },
  {
    businessName: 'apiInfo',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlApiInfoListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      addApiInfo: {
        api: urls.kUrlAddApiInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      deleteApiInfos: {
        api: urls.kUrlDeleteApiInfo,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      updateApiInfo: {
        api: urls.kUrlUpdateApiInfo,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateApiInfoByState: {
        api: urls.kUrlupdateApiInfoByState,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      getRoleApiListByQry: {
        api: urls.kUrlGetRoleApiListByQry,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      addRoleApiMany: {
        api: urls.kUrlAddRoleApiMany,
        methodType: 'POST',
        returnField: {},
        params: [],
      }
    }, initData: {}
  },
  {
    businessName: 'menu',
    modelType: 'entity',
    action: {
      getMenus: {
        api: urls.kUrlGetMenus,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getListByPage: {
        api: urls.kUrlMenuListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      changeDisable: {
        api: urls.kUrlChangeMenuDisable,
        methodType: 'PUT',
        returnField: {},
        params: ['ids'],
      },
      getMenusForTpye: {
        api: urls.kUrlGetMenusForTpye,
        methodType: 'GET',
        returnField: {},
        params: ['type'],
      },
      addMenu: {
        api: urls.kUrlAddMenu,
        methodType: 'POST',
        returnField: {},
        params: ['menu'],
      },
      updateMenu: {
        api: urls.kUrlUpdateMenu,
        methodType: 'PUT',
        returnField: {},
        params: ['menu'],
      },
      export: {
        api: urls.kUrlGetExportMenus,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'groupManagement',
    modelType: 'entity',
    action: {
      groupList: {
        api: urls.kUrlGroupListByPage,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      queryGroupList: {
        api: urls.kUrlQueryGroupList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      groupListFilter: {
        api: urls.kUrlGroupListByPageFilter,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      addGroup: {
        api: urls.kUrlAddGroup,
        methodType: 'POST',
        params: ['name', 'code'],
        returnField: {},
      },
      updateGroup: {
        api: urls.kUrlUpdateGroup,
        methodType: 'PUT',
        params: ['id', 'name', 'code'],
        returnField: {},
      },
      deleteGroup: {
        api: urls.kUrlDeleteGroup,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      updateGroupState: {
        api: urls.kUrlUpdateGroupState,
        methodType: 'PUT',
        params: ['id', 'state'],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'groupUserManagement',
    modelType: 'entity',
    action: {
      groupUserList: {
        api: urls.kUrlGroupUserListByPage,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      addGroupUser: {
        api: urls.kUrlAddGroupUser,
        methodType: 'POST',
        params: ['groupId', 'personIdList'],
        returnField: {},
      },
      addGroupUserByUser: {
        api: urls.kUrlAddGroupUserByUser,
        methodType: 'POST',
        params: ['personId', 'groupIds'],
        returnField: {},
      },
      deleteGroupUser: {
        api: urls.kUrlDeleteGroupUser,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      queryGroupUserList: {
        api: urls.kUrlQueryGroupUserList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'position',
    modelType: 'entity',
    action: {
      getById: {
        api: urls.kUrlPositionInfo,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      list: {
        api: urls.kUrlPositionPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      nofilterlist: {
        api: urls.kUrlPositionPageNoFilter,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlPositionAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlPositionUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      enable: {
        api: urls.kUrlPositionUpdateState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      delete: {
        api: urls.kUrlPositionBatchDelete,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      export: {
        api: urls.kUrlPositionExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'OrganizationZoneCode',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlOrganizationZoneCodePage,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      add: {
        api: urls.kUrlOrganizationZoneCodeAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlOrganizationZoneCodeUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      delete: {
        api: urls.kUrlOrganizationZoneCodeDelete,
        methodType: 'DELETE',
        params: [],
        returnField: {},
      },
      export: {
        api: urls.kUrlOrganizationZoneCodeExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      enable: {
        api: urls.kUrlOrganizationZoneCodeEnable,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'positionCategory',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlPositionCategoryPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      getPositionCategoryList: {
        api: urls.kUrlPositionCategoryList,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlPositionCategoryAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlPositionCategoryUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      delete: {
        api: urls.kUrlPositionCategoryBatchDelete,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'roleMenuElements',
    modelType: 'entity',
    action: {
      batchSave: {
        api: urls.kUrlAddRoleMenuElements,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      getMenuRightOfUse: {
        api: urls.kUrlGetMenuRightOfUse,
        methodType: 'GET',
        returnField: {},
        params: ['menuId']
      },
      getMenuPowerByRoleId: {
        api: urls.kUrlGetMenuPowerByRoleId,
        methodType: 'GET',
        returnField: {},
        params: ['roleId']
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'personManage',
    modelType: 'entity',
    action: {

      import: {
        api: urls.kUrlPersonInfoImport,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      importSchoolCooperationPerson: {
        api: urls.kUrlImportSchoolCooperationPerson,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      importPerson: {
        api: urls.kUrlImportPerson,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      personInfoExportRandomNumber: {
        api: urls.kUrlPersonInfoExportRandomNumber,
        methodType: 'GET',
        returnField: {},
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        params: [],
      },
      personInfoExport: {
        api: urls.kUrlPersonInfoExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      personIdentityInfoExport: {
        api: urls.kUrlPersonIdentityInfoExport,
        methodType: 'GET',
        returnField: {},
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        params: [],
      },
      getListByPage: {
        api: urls.kUrlPersonManage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      listByConfigPage: {
        api: urls.kUrlListByConfigPageForAbility,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getTeachelist: {
        api: urls.kUrlTeachManage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getPersonInfoByPersonIdList: {
        api: urls.kUrlQueryPersonOrgInfoByPersonId,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getPersonAndUserIdentitiesInfo: {
        api: urls.kUrlPersonAndUserIdentitiesInfo,
        methodType: 'GET',
        returnField: {},
        params: ['personId'],
      },
      enable: {
        api: urls.kUrlPersonManageEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlPersonManageAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlPersonManageUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      reset: {
        api: urls.kUrlPsersonResetPassword,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      batchChangeState: {
        api: urls.kUrlPersonBatchChangeState,
        methodType: 'PUT',
        returnField: {},
        params: [],
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'dealer',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlDealerPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlDealerAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlDealerUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      delete: {
        api: urls.kUrlDealerBatchDelete,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      export: {
        api: urls.kUrlDealerExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      look: {
        api: urls.kUrlDealerLook,
        methodType: 'GET',
        params: ['id'],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'roleSets',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlRoleSetsListByCondition,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      delete: {
        api: urls.kUrlDeleteRoleSet,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      addRoleSet: {
        api: urls.kUrlAddRoleSet,
        methodType: 'POST',
        params: ['name'],
        returnField: {},
      },
      updateRoleSet: {
        api: urls.kUrlUpdateRoleSet,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'roleSetsRole',
    modelType: 'entity',
    action: {
      addRoleSetsRole: {
        api: urls.kUrlAddRoleSetsRole,
        methodType: 'POST',
        returnField: {},
        params: ['roleSetsId'],
      },
      list: {
        api: urls.kUrlRoleSetsRoleList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'roleManagement',
    modelType: 'entity',
    action: {
      batchSave: {
        api: urls.kUrlRoleManagementBatchSave,
        methodType: 'POST',
        returnField: {},
        params: ['roleSetsId'],
      },
      list: {
        api: urls.kUrlRoleManagementList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'dealerUnion',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlDealerUnionPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      import: {
        api: urls.kUrlDealerUnionImport,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      export: {
        api: urls.kUrlDealerUnionExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      enable: {
        api: urls.kUrlDealerUnionUpdateState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'categoryType',
    modelType: 'entity',
    action: {
      nodeList: {
        api: urls.kUrlCategoryInfoNodeList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      categoryList: {
        api: urls.kUrlCategoryInfoList,
        methodType: 'GET',
        params: ['type'],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'questionType',
    modelType: 'entity',
    action: {
      authInfo: {
        api: urls.kUrlCategoryAuthInfo,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      saveAuth: {
        api: urls.kUrlCategorySaveAuth,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      import: {
        api: urls.kUrlImportCategoryInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      export: {
        api: urls.kUrlExportCategoryInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      normalListByPage: {
        api: urls.kUrlCategoryNormalInfoListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByPage: {
        api: urls.kUrlCategoryInfoListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      normalNodeList: {
        api: urls.kUrlCategoryInfoNormalNodeList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      userNodeList: {
        api: urls.kUrlCategoryInfoUserNodeList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      nodeList: {
        api: urls.kUrlCategoryInfoNodeList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      add: {
        api: urls.kUrlAddCategoryInfo,
        methodType: 'POST',
        params: ['name', 'state', 'type'],
        returnField: {},
      },
      upd: {
        api: urls.kUrlUpdCategoryInfo,
        methodType: 'PUT',
        params: ['id', 'name', 'state', 'type'],
        returnField: {},
      },
      del: {
        api: urls.kUrlDelCategoryInfo,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      enable: {
        api: urls.kUrlEnableCategoryInfo,
        methodType: 'PUT',
        params: ['ids', 'state'],
        returnField: {},
      },
      listByPageNew: {
        api: urls.kUrlCategoryInfoListByPageNew,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  }, {
    businessName: 'program',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlProgramListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddProgram,
        methodType: 'POST',
        returnField: {},
        params: ['name', 'scoId', 'status'],
      },
      update: {
        api: urls.kUrlUpdateProgram,
        methodType: 'PUT',
        returnField: {},
        params: ['name', 'scoId', 'id'],
      },
      UpdateProgramStatus: {
        api: urls.kUrlUpdateProgramStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['idList', 'status'],
      },
      export: {
        api: urls.kUrlExportProgram,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      authInfo: {
        api: urls.kUrlProgramAuthInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      saveAuth: {
        api: urls.kUrlProgramSaveAuth,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlDeleteProgram,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      getProgramById: {
        api: urls.kUrlGetProgramById,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
    }, initData: {}
  }, {
    businessName: 'scheduleManagement',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlScheduleListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddSchedule,
        methodType: 'POST',
        returnField: {},
        params: ['name'],
      },
      update: {
        api: urls.kUrlUpdateSchedule,
        methodType: 'PUT',
        returnField: {},
        params: ['name', 'id'],
      },
      delete: {
        api: urls.kUrlDeleteSchedule,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      updateScheduleStatus: {
        api: urls.kUrlUpdateScheduleStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['idList', 'status'],
      },
      export: {
        api: urls.kUrlExportSchedule,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  }, {
    businessName: 'login',
    modelType: 'entity',
    action: {
      doLogin: {
        api: urls.kUrlLogin,
        methodType: 'POST',
        params: ['username', 'password', 'captchaCode', 'uuid', 'platform'],
        returnField: {},
        requestConfig: {
          headers: {
            'source': 3,
            'content-type': 'application/json',
            'endpoint': 'admin'
          },
        }
      },
      doLogout: {
        api: urls.kUrlLogout,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      logout: {
        api: urls.kUrlLogout,
        methodType: 'POST',
        params: [],
        returnField: {},
        requestConfig: {
          headers: {
            'source': 3,
            'content-type': 'application/json',
            'endpoint': 'admin'
          },
        }
      }
    },
    initData: {}
  },
  {
    businessName: 'captcha',
    modelType: 'entity',
    action: {
      getImageCaptcha: {
        api: urls.kUrlImageCaptcha,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getCaptchaCode: {
        api: urls.kUrlCaptchaCode,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  }, {
    businessName: 'examRecord',
    modelType: 'entity',
    action: {
      exportByQuestionAnswerDetail: {
        api: urls.KUrlExamQuestionAnswerDetail,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      exportByQuestionAnswerDetailLook: {
        api: urls.KUrlExamQuestionAnswerDetail,
        methodType: 'GET',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            endpoint: 'user',
            authority: 'look'
          }
        }
      },
      exportByStudentAnswerDetail: {
        api: urls.kUrlExamStudentAnswerDetail,
        methodType: 'GET',
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        returnField: {}, params: [],
      },
      exportByStudentAnswerDetailLook: {
        api: urls.kUrlExamStudentAnswerDetail,
        methodType: 'GET',
        requestConfig: {
          responseType: 'blob',
          endpoint: 'user',
          authority: 'look'
        },
        returnField: {}, params: [],
      },
      list: {
        api: urls.kUrlExamRecordPage,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      listLook: {
        api: urls.kUrlExamRecordPage,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            endpoint: 'user',
            authority: 'look'
          }
        }
      },
      reviewedPaper: {
        api: urls.kUrlReviewedPaper,
        methodType: 'POST',
        returnField: {}, params: ['ids'],
      },
      gradePageList: {
        api: urls.kUrlExamGradePage,
        methodType: 'POST',
        returnField: {}, params: ['examId']
      },
      infoPageList: {
        api: urls.kUrlExamInfoPage,
        methodType: 'POST',
        returnField: {}, params: ['examId']
      },
      infoPageListLook: {
        api: urls.kUrlExamInfoPage,
        methodType: 'POST',
        returnField: {},
        params: ['examId'],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            endpoint: 'user',
            authority: 'look'
          }
        }
      },
      export: {
        api: urls.kUrlExamRecordExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportLook: {
        api: urls.kUrlExamRecordExport,
        methodType: 'GET',
        params: [],
        returnField: {},
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            endpoint: 'user',
            authority: 'look'
          }
        }
      },
      infoExport: {
        api: urls.kUrlExamRecordInfoExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      gradeExportByPosition: {
        api: urls.kUrlExamGradeInfoExportByPosition,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      gradeExportByPositionLook: {
        api: urls.kUrlExamGradeInfoExportByPosition,
        methodType: 'GET',
        params: [],
        returnField: {},
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            endpoint: 'user',
            authority: 'look'
          }
        }
      },
      gradeExportByPositionInfo: {
        api: urls.kUrlExamGradeInfoExportByPositionInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      gradeExportByPositionInfoLook: {
        api: urls.kUrlExamGradeInfoExportByPositionInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            endpoint: 'user',
            authority: 'look'
          }
        }
      },
      infoCharts: {
        api: urls.kUrlExamRecordInfoCharts,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      gradeCharts: {
        api: urls.kUrlExamGradeInfoCharts,
        methodType: 'GET',
        params: [],
        returnField: {},
      },

      getErrorQuetionPage: {
        api: urls.kUrlErrorQuetionPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      getErrorQuestionAnswerPage: {
        api: urls.kUrlErrorQuestionAnswerPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      getErrorQuestionPersonInfoPage: {
        api: urls.kUrlErrorQuestionPersonInfoPage,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      getErrorQuestionPersonInfoAnalysisPage: {
        api: urls.KUrlErrorQuestionPersonInfoAnalysisPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },

      getErrorQuetionExport: {
        api: urls.kUrlErrorQuetionExport,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      getErrorQuestionAnswerExport: {
        api: urls.kUrlErrorQuestionAnswerExport,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      getErrorQuestionPersonInfoExport: {
        api: urls.kUrlErrorQuestionPersonInfoExport,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      getErrorQuestionPersonInfoAnalysisExport: {
        api: urls.KUrlErrorQuestionPersonInfoAnalysisExport,
        methodType: 'GET',
        returnField: {}, params: [],
      },

    },
    initData: {}
  }, {
    businessName: 'bankQuestion',
    modelType: 'entity',
    action: {
      export: {
        api: urls.kUrlBankQuestionExport,
        methodType: 'GET',

        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        returnField: {},
        params: [],
      },
      import: {
        api: urls.kUrlBankQuestionImport,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      queryCount: {
        api: urls.kUrlBankQueryCount,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      normalListByPage: {
        api: urls.kUrlBankQuestionNormalListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      userListByPage: {
        api: urls.kUrlBankQuestionUserListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByPage: {
        api: urls.kUrlBankQuestionListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      bankQuestionInfo: {
        api: urls.kUrlBankQuestionInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlAddBankQuestion,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlUpdBankQuestion,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlDelBankQuestion,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
    },
    initData: {}
  }, { // 主观题批阅
    businessName: 'subjectiveReview',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlExamManualReviewPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      export: {
        api: urls.kUrlExamManualReviewExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  }, { // 主观题批阅-学员考试记录
    businessName: 'examinationRecord',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlExamPaperReviewPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      export: {
        api: urls.kUrlExamPaperReviewExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      reviewInfo:{ // 获取批阅展示
        api: urls.kUrlExamPaperReviewInfo,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      look:{ // 查看
        api: urls.kUrlExamPaperReviewLook,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      confirmReview:{ // 批阅确认 确认下一步
        api: urls.kUrlExamPaperReviewConfirmReview,
        methodType: 'PUT',
        returnField: {},
        params: [],
      }
    },
    initData: {}
  }, {
    businessName: 'exam',
    modelType: 'entity',
    action: {
      getExamById: {
        api: urls.kUrlExamInfoById,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      importExamQuestion: {
        api: urls.kUrlExamQuestionImport,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      authInfo: {
        api: urls.kUrlExamAuthInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      targetScopeInfo: {
        api: urls.kUrlExamTargetScopeInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      export: {
        api: urls.kUrlExamExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      saveAuth: {
        api: urls.kUrlExamSaveAuth,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      getListByPage: {
        api: urls.kUrlExamListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      publish: {
        api: urls.kUrlExamPublish,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      close: {
        api: urls.kUrlExamClose,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      chapterPreviewInfo: {
        api: urls.kUrlChapterPreviewInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      createExam: {
        api: urls.kUrlCreateExam,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateExam: {
        api: urls.kUrlUpdateExam,
        methodType: 'POST',
        returnField: {},
        params: ['id'],
      },
      saveChapter: {
        api: urls.kUrlAddExamChapter,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      chapterInfo: {
        api: urls.kUrlExamChapterInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      lookPreviewInfo: {
        api: urls.kUrlExamLookPreviewInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      previewInfo: {
        api: urls.kUrlExamPreviewInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      delExam: {
        api: urls.kUrlDelExam,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      changeExamFaceAuth: {
        api: urls.kUrlChangeExamFaceAuth,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  }, {
    businessName: 'examPaper',
    modelType: 'entity',
    action: {
      fullMarkPaper: {
        api: urls.kUrlFullMarkPaper,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      delPaper: {
        api: urls.kUrlDelPaper,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'examTemplateRelation',
    modelType: 'entity',
    action: {
      update: {
        api: urls.kUrlExamTemplateRelationUpdate,
        methodType: 'PUT',
        returnField: {}, params: [],
      },
      listByPage: {
        api: urls.kUrlExamTemplateRelationListByCondition,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      enable: {
        api: urls.kUrlExamTemplateRelationEnable,
        methodType: 'PUT',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlExamTemplateRelationAdd,
        methodType: 'POST',
        returnField: {}, params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'examTemplateGroup',
    modelType: 'entity',
    action: {
      getExamTemplateGroupById: {
        api: urls.kUrlExamTemplateGroupById,
        methodType: 'GET',
        returnField: {}, params: []
      },
      listByPage: {
        api: urls.kUrlExamTemplateGroupListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      enable: {
        api: urls.kUrlExamTemplateGroupEnable,
        methodType: 'PUT',
        params: ['ids', 'status'],
        returnField: {},
      },
      del: {
        api: urls.kUrlExamTemplateGroupBatchDelete,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      add: {
        api: urls.kUrlExamTemplateGroupAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlExamTemplateGroupUpdate,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      export: {
        api: urls.kUrlExamTemplateGroupExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      saveAuth: {
        api: urls.kUrlExamTemplateGroupSaveAuth,
        methodType: 'POST',
        returnField: {},
        params: ['id'],
      },
      authInfo: {
        api: urls.kUrlExamTemplateGroupAuthInfo,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      }
    },
    initData: {}
  },

  {
    businessName: 'examTemplate',
    modelType: 'entity',
    action: {
      getExamTemplateById: {
        api: urls.kUrlExamTemplateById,
        methodType: 'GET',
        returnField: {}, params: []
      },
      lookPreviewInfo: {
        api: urls.kUrlExamTemplateLookPreviewInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      listByPage: {
        api: urls.kUrlExamTemplateListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      enable: {
        api: urls.kUrlExamTemplateEnable,
        methodType: 'PUT',
        params: ['ids', 'state'],
        returnField: {},
      },
      createExamTemplate: {
        api: urls.kUrlCreateExamTemplate,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateExamTemplate: {
        api: urls.kUrlUpdateExamTemplate,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      chapterInfo: {
        api: urls.kUrlExamTemplateChapterInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      saveChapter: {
        api: urls.kUrlSaveExamTemplateChapter,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      delete: {
        api: urls.kUrlExamTemplateBatchDelete,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      export: {
        api: urls.kUrlExamTemplateExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      }
    },
    initData: {}
  },
  {
    businessName: 'programEntity',
    modelType: 'entity',
    action: {
      batchSave: {
        api: urls.kUrlAddProgramEntity,
        methodType: 'POST',
        returnField: {}, params: ['programId'],
      },
      getListByProgramId: {
        api: urls.kUrlGetProgramEntity,
        methodType: 'GET',
        returnField: {}, params: ['programId'],
      },
    },
    initData: {}
  },

  {
    businessName: 'live',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlLiveListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      update: {
        api: urls.kUrlUpdateLive,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      setLiveStatus: {
        api: urls.kUrlSetLiveStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['id', 'status'],
      },
      add: {
        api: urls.kUrlAddLive,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      listByCondition: {
        api: urls.kUrlGetLiveList,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      authInfo: {
        api: urls.kUrlLiveAuthInfo,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      saveAuth: {
        api: urls.kUrlLiveSaveAuth,
        methodType: 'POST',
        returnField: {},
        params: ['id'],
      },
    },
    initData: {}
  },   //互动直播   参训记录
  {
    businessName: 'liveRecord',
    modelType: 'entity',
    action: {
      getPageList: {
        api: urls.kUrlLiveRecordGetPageList,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      export: {
        api: urls.kUrlLiveRecordExport,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      syncLiveRecord: {
        api: urls.kUrlLiveRecordSyncRecord,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
    },
    initData: {}
  },
  {
    businessName: 'offlineProgramManagement',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlOfflineProgramListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getOfflineProgram: {
        api: urls.kUrlGetOfflineProgram,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      add: {
        api: urls.kUrlAddOfflineProgram,
        methodType: 'POST',
        returnField: {},
        params: ['name', 'code', 'types',],
      },
      update: {
        api: urls.kUrlUpdateOfflineProgram,
        methodType: 'PUT',
        returnField: {},
        params: ['name', 'code', 'types', 'id'],
      },
      delete: {
        api: urls.kUrlDeleteOfflineProgram,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      updateOfflineProgramStatus: {
        api: urls.kUrlUpdateOfflineProgramStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['idList', 'status'],
      },
      export: {
        api: urls.kUrlExportOfflineProgram,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  }, {
    businessName: 'classManagement',
    modelType: 'entity',
    action: {
      listByCondPage: {
        api: urls.kUrlClassListByCondPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getListByPage: {
        api: urls.kUrlClassListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddClass,
        methodType: 'POST',
        returnField: {},
        params: ['name'],
      },
      update: {
        api: urls.kUrlUpdateClass,
        methodType: 'PUT',
        returnField: {},
        params: ['name', 'id'],
      },
      delete: {
        api: urls.kUrlDeleteClass,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      updateClassStatus: {
        api: urls.kUrlUpdateClassStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['id', 'status'],
      },
      export: {
        api: urls.kUrlExportClass,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      exportLabels: {
        api: urls.kUrlExportLabels,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getClassAideRemoteAuthInfo: {
        api: urls.kUrlGetClassAideRemoteAuthInfo,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getClassById: {
        api: urls.kUrlGetClassById,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      createClassTeam: {
        api: urls.kUrlCreateClassTeam,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      removeClassTeam: {
        api: urls.kUrlRemoveClassTeam,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      syncClassTeam: {
        api: urls.kUrlSyncClassTeam,
        methodType: 'GET',
        returnField: {},
        params: [],
      },

    },
    initData: {}
  }, {
    businessName: 'classResult',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlClassResultByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getListInfo: {
        api: urls.kUrlClassResultInfo,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddClassResult,
        methodType: 'POST',
        returnField: {},
        params: ['name'],
      },
      update: {
        api: urls.kUrlUpdateClassResult,
        methodType: 'PUT',
        returnField: {},
        params: ['id', 'status', 'score', 'comment'],
      },
      delete: {
        api: urls.kUrlDeleteClassResult,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      batchUpdate: {
        api: urls.kUrlBatchUpdateClassResult,
        methodType: 'PUT',
        returnField: {},
        params: ['ids', 'status', 'score', 'comment'],
      },
      export: {
        api: urls.kUrlExportClassResult,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      import: {
        api: urls.kUrlImportClassResult,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      importFileForApply: {
        api: urls.kUrlImportClassResultApply,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      }
    },
    initData: {}
  }, {
    businessName: 'classAideManagement',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlClassAideListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      list: {
        api: urls.kUrlClassAideList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getAllClassAideInfoByClassId: {
        api: urls.kUrlGetAllClassAideInfoByClassId,
        methodType: 'GET',
        returnField: {},
        params: ['classId'],
      },
      getClassAide: {
        api: urls.kUrlGetClassAide,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      add: {
        api: urls.kUrlAddClassAide,
        methodType: 'POST',
        returnField: {},
        params: ['name'],
      },
      update: {
        api: urls.kUrlUpdateClassAide,
        methodType: 'PUT',
        returnField: {},
        params: ['name', 'id'],
      },
      saveOrUpdateEntityInfo: {
        api: urls.kUrlSaveOrUpdateEntityInfo,
        methodType: 'POST',
        returnField: {},
        params: ['aideTypeId', 'classId'],
      },
      delete: {
        api: urls.kUrlDeleteClassAide,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      updateClassAideStatus: {
        api: urls.kUrlUpdateClassAideStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['idList', 'status'],
      },
      export: {
        api: urls.kUrlExportClassAide,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getClassInfoById: {
        api: urls.kUrlGetClassInfoById,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
    },
    initData: {}
  }, {
    businessName: 'classLinkUpOrDown',
    modelType: 'entity',
    action: {
      update: {
        api: urls.updateClassAideOrderNum,
        methodType: 'PUT',
        returnField: {},
        params: ['classInfoId', 'classAideId','type'],
      },
    },
    initData: {}
  }, {
    businessName: 'aideTypeManagement',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlAideTypeListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      list: {
        api: urls.kUrlAideTypeList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getAideType: {
        api: urls.kUrlGetAideType,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      add: {
        api: urls.kUrlAddAideType,
        methodType: 'POST',
        returnField: {},
        params: ['name'],
      },
      update: {
        api: urls.kUrlUpdateAideType,
        methodType: 'PUT',
        returnField: {},
        params: ['name', 'id'],
      },
      delete: {
        api: urls.kUrlDeleteAideType,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      updateAideTypeStatus: {
        api: urls.kUrlUpdateAideTypeStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['idList', 'status'],
      },
      export: {
        api: urls.kUrlExportAideType,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  }, {
    businessName: 'classStudentManagement',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlClassStudentListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getList: {
        api: urls.kUrlClassStudentList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getClassStudent: {
        api: urls.kUrlClassStudentById,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      getPersonIdsByClassInfoId: {
        api: urls.kUrlGetClassStudentPersonIds,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      add: {
        api: urls.kUrlAddClassStudent,
        methodType: 'POST',
        returnField: {},
        params: ['classStudents'],
      },
      update: {
        api: urls.kUrlUpdateClassStudent,
        methodType: 'PUT',
        returnField: {},
        params: ['name', 'id'],
      },
      delete: {
        api: urls.kUrlDeleteStudentClass,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      exportQuestionnaire: {
        api: urls.kUrlExportClassStudentQuestionnaire,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      exportPerson: {
        api: urls.kUrlExportClassStudentPerson,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      leaveState: {
        api: urls.kUrlLeaveStudentClass,
        methodType: 'PUT',
        returnField: {},
        params: ['id', 'leaveState'],
      },
      import: {
        api: urls.kUrlClassStudentImport,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      remoteAuthByPage: {
        api: urls.kUrlQueryClassStudentRemoteAuthPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      remoteAuthByList: {
        api: urls.kUrlQueryClassStudentRemoteAuthList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      interactLiveByPage: {
        api: urls.kUrlQueryClassStudentInteractLivePage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      interactLiveByList: {
        api: urls.kUrlQueryClassStudentInteractLiveList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      syncLiveRecord: {
        api: urls.kUrlLiveRecordSyncRecord,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
      NEVAuthByPage: {
        api: urls.kUrlQueryClassStudentNEVRemoteAuthPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      NEVAuthByList: {
        api: urls.kUrlQueryClassStudentNEVRemoteAuthList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      NEVUpdateAuthState: {
        api: urls.kUrlNEVUpdateAuthState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      programResultByPage: {
        api: urls.kUrlQueryClassStudentProgramPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      programResultByList: {
        api: urls.kUrlQueryClassStudentProgramList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      contentRecordByPage: {
        api: urls.kUrlQueryClassStudentContentPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      contentRecordByList: {
        api: urls.kUrlQueryClassStudentContentList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'classAnnouncement',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlQueryClassAnnouncementPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlQueryClassAnnouncementList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      save: {
        api: urls.kUrlQueryClassAnnouncementSave,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlQueryClassAnnouncementUpd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: []
  },
  {
    businessName: 'classAlbum',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlQueryClassAlbumPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      list: {
        api: urls.kUrlQueryClassAlbumList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlQueryClassAlbumAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      del: {
        api: urls.kUrlQueryClassAlbumDel,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
    },
    initData: []
  },
  {
    businessName: 'studentSign',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlStudentSignListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      listByCondition: {
        api: urls.kUrlGetSignList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      setStudentSignStatus: {
        api: urls.kUrlSetStudentSignStatus,
        methodType: 'PUT',
        returnField: {},
        params: ['id', 'status'],
      },
      setStudentSignStatusByBatch: {
        api: urls.kUrlSetStudentSignStatusByBatch,
        methodType: 'PUT',
        returnField: {},
        params: ['idList', 'status'],
      },
    },
    initData: []
  },
  {
    businessName: 'sign',
    modelType: 'entitysign',
    action: {
      getSignDetailById: {
        api: urls.kUrlGetSignDetailById,
        methodType: 'GET',
        returnField: {},
        params: [],
      }
    },
    initData: {}
  },
  {
    businessName: 'survey',
    modelType: 'entity',
    action: {
      findSurveyAnswerById: {
        api: urls.kUrlFindSurveyAnswerById,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      list: {
        api: urls.kUrlSurveyListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getSurveyInfo: {
        api: urls.kUrlGetSurveyInfo,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      createQuestions: {
        api: urls.kUrlCreateQuestions,
        methodType: 'POST',
        returnField: {},
        params: ['surveyId', 'questions'],
      },
      updateQuestions: {
        api: urls.kUrlUpdateQuestions,
        methodType: 'PUT',
        returnField: {},
        params: ['surveyId', 'questions'],
      },
      add: {
        api: urls.kUrlSurveyAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlSurveyUpdate,
        methodType: 'PUT',
        returnField: {},
        params: ['id', 'title', 'type'],
      },
      delete: {
        api: urls.kUrlSurveyBatchDelete,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      enable: {
        api: urls.kUrlSurveyUpdateState,
        methodType: 'PUT',
        params: ['id', 'status'],
        returnField: {},
      },
      exportSurvey: {
        api: urls.kUrlSurveyExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      surveyAnswerList: {
        api: urls.kUrlSurveyAnswerPageList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      targetScopeInfo: {
        api: urls.kUrlSurveyTargetScopeInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      authInfo: {
        api: urls.kUrlSurveyAuthInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      saveAuth: {
        api: urls.kUrlSurveySaveAuth,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      surveyResult: {
        api: urls.kUrlSurveyResult,
        methodType: 'GET',
        returnField: {},
        params: [],
      }
    },
    initData: {}
  },
  {
    businessName: 'surveyAnswer',
    modelType: 'entity',
    action: {
      surveyAnswerList: {
        api: urls.kUrlSurveyAnswerList,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'surveyTemplate',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlSurveyTemplateListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getSurveyTemplateInfo: {
        api: urls.kUrlGetSurveyTemplateInfo,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      createTemplateQuestions: {
        api: urls.kUrlCreateTemplateQuestions,
        methodType: 'POST',
        returnField: {},
        params: ['surveyTemplateId', 'questions'],
      },
      updateTemplateQuestions: {
        api: urls.kUrlUpdateTemplateQuestions,
        methodType: 'PUT',
        returnField: {},
        params: ['surveyTemplateId', 'questions'],
      },
      add: {
        api: urls.kUrlSurveyTemplateAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlSurveyTemplateUpdate,
        methodType: 'PUT',
        returnField: {},
        params: ['id', 'title', 'type'],
      },
      enable: {
        api: urls.kUrlSurveyTemplateUpdateState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      delete: {
        api: urls.kUrlSurveyTemplateBatchDelete,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'ossUpload',
    modelType: 'entity',
    action: {
      addUploadSystemFileInfo: {
        api: urls.kUrlAddUploadSystemFileInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      addUploadCourseWareFileInfo: {
        api: urls.kUrlAddUploadCourseWareFileInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      addUploadTempFileInfo: {
        api: urls.kUrlAddUploadTempFileInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      uploadFileUpdateCmd: {
        api: urls.kUrlUploadFileUpdateCmd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      getFileUploadParam: {
        api: urls.kUrlGetFileUploadParam,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getFileInfoList: {
        api: urls.kUrlGetQueryFileInfoList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getFileInfoByFileId: {
        api: urls.kUrlGetFileInfoByFileId,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getFileInfoByIds: {
        api: urls.kUrlGetFileInfoByIds,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'classStudentExam',
    modelType: 'entityClassStudentExam',
    action: {
      queryClassExamInfo: {
        api: urls.kUrlQueryClassExamInfo,
        methodType: 'GET',
        returnField: {},
        params: ['examId', 'classInfoId'],
      },
      queryStudentExamPage: {
        api: urls.kUrlQueryStudentExamPage,
        methodType: 'GET',
        returnField: {},
        params: ['examId', 'classInfoId'],
      },
      exportStudentExamByCondition: {
        api: urls.kUrlExportStudentExamByCondition,
        methodType: 'GET',
        returnField: {},
        params: ['examId', 'classInfoId'],
      },
      exportStudentExamByAllIdentity: {
        api: urls.kUrlExportStudentExamByAllIdentity,
        methodType: 'GET',
        returnField: {},
        params: ['examId', 'classInfoId'],
      }
    },
    initData: {}
  },
  //create by zy 查看问卷接口 2020-04-30
  {
    businessName: 'classStudentSurvey',
    modelType: 'entityClassStudentSurvey',
    action: {
      queryClassStudentSurveySummary: {
        api: urls.kUrlQueryClassStudentSurveySummary,//图表统计接口
        methodType: 'GET',
        returnField: {},
        params: ['surveyId', 'classInfoId'],
      },
      queryClassStudentSurveyPage: {
        api: urls.kUrlQueryClassStudentSurveyPage,//列表分页查询接口
        methodType: 'GET',
        returnField: {},
        params: ['surveyId', 'classInfoId'],
      },
      exportClassStudentSurveyByCondition: {
        api: urls.kUrlExportClassStudentSurveyByCondition,//列表班级学员问卷信息接口
        methodType: 'GET',
        returnField: {},
        params: ['surveyId', 'classInfoId'],
      },
      exportClassStudentSurveyDetailByCondition: {
        api: urls.kUrlExportClassStudentSurveyDetailByCondition,//列表班级学员问卷信息接口
        methodType: 'GET',
        returnField: {},
        params: ['surveyId', 'classInfoId'],
      }
    },
    initData: {}
  },
  //create by xyguo 查看问卷接口 2020-12-14
  {
    businessName: 'classStudentHomework',
    modelType: 'entity',
    action: {
      queryClassStudentHomeworkPage: {
        api: urls.kUrlQueryClassStudentHomeworkPage,//列表分页查询接口
        methodType: 'GET',
        returnField: {},
        params: ['entityId', 'classInfoId'],
      },
      exportClassStudentHomework: {
        api: urls.kUrlexportClassStudentHomework,//列表导出接口
        methodType: 'GET',
        returnField: {},
        params: ['entityId', 'classInfoId'],
      }
    },
    initData: {}
  },
  {
    businessName: 'trainCenter',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlTrainCenterPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlTrainCenterAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlTrainCenterUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      info: {
        api: urls.kUrlTrainCenterList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'trainCenterForTableForm',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlTrainCenterPage,
        methodType: 'GET',
        returnField: {}, params: [],
      }
    },
    initData: {}
  },
  {
    businessName: 'trainSite',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlTrainSitePage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      appointmentList: {
        api: urls.kUrlTrainSiteAppointmentList,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlTrainSiteAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlTrainSiteUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      look: {
        api: urls.kUrlTrainSiteLook,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      export: {
        api: urls.kUrlTrainSiteExport,
        methodType: 'GET',
        returnField: {}, params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'classroom',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlClassroomListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      create: {
        api: urls.kUrlClassroomCreate,
        methodType: 'POST',
        params: ['name', 'code', 'trainCenterId', 'city', 'type', 'purpose', 'auditType', 'status'],
        returnField: {},
      },
      update: {
        api: urls.kUrlClassroomUpdate,
        methodType: 'PUT',
        params: ['id', 'name', 'code', 'trainCenterId', 'city', 'type', 'purpose', 'auditType', 'status'],
        returnField: {},
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'siteOrder',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlSiteOrderListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      list: {
        api: urls.kUrlSiteOrderList,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      create: {
        api: urls.kUrlCreateSiteOrder,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlUpdateSiteOrder,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
      cancel: {
        api: urls.kUrlCancel,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
      appointmentReview: {
        api: urls.kUrlAppointmentReview,
        methodType: 'PUT',
        params: ['ids'],
        returnField: {},
      },
      export: {
        api: urls.kUrlSiteOrderExport,
        methodType: 'GET',
        returnField: {}, params: [],
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'siteOrderCheck',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlSiteOrderCheckListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      verify: {
        api: urls.kUrlVerifySiteOrderCheck,
        methodType: 'PUT',
        params: ['ids'],
        returnField: {},
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'siteEquipment',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlSiteEquipmentListByPage,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      create: {
        api: urls.kUrlSiteEquipmentCreate,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlSiteEquipmentUpdate,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      export: {
        api: urls.kUrlSiteEquipmentExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'siteOrderStatistic',
    modelType: 'entity',
    action: {
      appointmentStatistic: {
        api: urls.kUrlAppointmentStatistic,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      verifyStatistic: {
        api: urls.kUrlVerifyStatistic,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      exportVerify: {
        api: urls.kUrlExportVerify,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      appointmentArrangement: {
        api: urls.kUrlAppointmentArrangement,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      exportAppointmentArrangement: {
        api: urls.kUrlExportAppointmentArrangement,
        methodType: 'GET',
        returnField: {}, params: [],
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'topic',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlTopicListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      baseListByPage: {
        api: urls.kUrlTopicBaseListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      basePageByDataPermission: {
        api: urls.kUrlTopicBasePageByDataPermission,
        methodType: 'GET',
        returnField: {}, params: []
      },
      create: {
        api: urls.kUrlCreateTopic,
        methodType: 'POST',
        returnField: {}, params: []
      },
      update: {
        api: urls.kUrlUpdateTopic,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      enable: {
        api: urls.kUrlEnableTopic,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      topping: {
        api: urls.kUrlTopicTopping,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlExportTopic,
        methodType: 'GET',
        returnField: {}, params: []
      },
      look: {
        api: urls.kUrlTopicLook,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'topicFollow',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlTopicFollowListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlTopicFollowExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'featured',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlFeaturedList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      listByPage: {
        api: urls.kUrlFeaturedListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      create: {
        api: urls.kUrlCreateFeatured,
        methodType: 'POST',
        returnField: {}, params: []
      },
      update: {
        api: urls.kUrlUpdateFeatured,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      find: {
        api: urls.kUrlFindFeatured,
        methodType: 'GET',
        returnField: {}, params: []
      },
      updateState: {
        api: urls.kUrlUpdateFeaturedState,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlExportFeatured,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: { data: {} }
  },
  {
    businessName: 'messageTask',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlMessageTaskListByPage,
        methodType: 'POST',
        returnField: {}, params: []
      },
      save: {
        api: urls.kUrlMessageTaskSave,
        methodType: 'POST',
        returnField: {}, params: []
      }
    },
    initData: { data: {} }
  },
  { //岗位能力评估管理
    businessName: 'abilityCheckCategory',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlAbilityCheckCategoryListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByCondition: {
        api: urls.kUrlAbilityCheckCategoryList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlAbilityCheckCategoryAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlAbilityCheckCategoryUpdate,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
      updateState: {
        api: urls.kUrlAbilityCheckCategoryUpdateState,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  { //能力项
    businessName: 'abilityItem',
    modelType: 'entity',
    action: {
      listByCondition: {
        api: urls.kUrlAbilityItemListByCondition,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      batchSave: {
        api: urls.kUrlAbilityItemBatchSave,
        methodType: 'POST',
        params: ['abilityCheckCategoryId'],
        returnField: {},
      }, delete: {
        api: urls.kUrlAbilityItemDelItmeById,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {}
      },
    },
    initData: { data: [] }
  },
  { //学员能力项详情
    businessName: 'studentAbilityItem',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlStudentAbilityItemGetPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlStudentAbilityItemAdd,
        params: [],
        returnField: {},
      },
      delete: {
        api: urls.kUrlStudentAbilityItemDel,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      exportHead: {
        api: urls.kUrlStudentAbilityItemGetExportHead,
        methodType: 'GET',
        params: ['id'],
        returnField: {},
      },
      export: {
        api: urls.kUrlStudentAbilityItemExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      import: {
        api: urls.kUrlStudentAbilityItemImportFile,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      getStudentAbilityItemPersonIdList: {
        api: urls.kUrlGetStudentAbilityItemPersonIdList,
        methodType: 'GET',
        params: ['id'],
        returnField: {}
      },
      update: {
        api: urls.kUrlStudentAbilityItemUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  { //岗位能力评估星级管理
    businessName: 'abilityCheckItem',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlAbilityCheckItemListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByCondition: {
        api: urls.kUrlAbilityCheckItemList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlAbilityCheckItemAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlAbilityCheckItemUpdate,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
      updateState: {
        api: urls.kUrlAbilityCheckItemUpdateState,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
      export: {
        api: urls.kUrlAbilityCheckItemExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  { //能力项详情管理
    businessName: 'abilityItemDetail',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlAbilityItemDetailListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByCondition: {
        api: urls.kUrlAbilityItemDetailList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listItemsByCondition: {
        api: urls.kUrlAbilityItemDetailListItems,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlAbilityItemDetailAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlAbilityItemDetailUpdate,
        methodType: 'POST',
        params: ['id'],
        returnField: {},
      },
      updateState: {
        api: urls.kUrlAbilityItemDetailUpdateState,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  { //岗位能力评估管理
    businessName: 'abilityAssess',
    modelType: 'entity',
    action: {
      getStudentAllAbilityItemByPersonId: {
        api: urls.kUrlGetStudentAllAbilityItemByPersonId,
        methodType: 'GET',
        params: [],
        returnField: {}
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'model',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlModelListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      addModel: {
        api: urls.kUrlAddModel,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      deleteModel: {
        api: urls.kUrlDeleteModel,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      updateModel: {
        api: urls.kUrlUpdateModel,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      deployModel: {
        api: urls.kUrlDeployModel,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'procdef',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlProcdefListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      deleteProcdef: {
        api: urls.kUrlDeleteProcdef,
        methodType: 'DELETE',
        returnField: {},
        params: ['cascade'],
      },
      updateSuspensionState: {
        api: urls.kUrlUpdateProcdefSuspensionState,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      viewResource: {
        api: urls.kUrlViewProcedefResource,
        methodType: 'GET',
        returnField: {},
        params: [],
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        }
      },
    },
    initData: {}
  },
  {
    businessName: 'workflowAudit',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlWorkflowAuditListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      saveAudit: {
        api: urls.kUrlSaveAudiSt,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      saveAuth: {
        api: urls.kUrlAuditUserSaveAuth,
        methodType: 'POST',
        returnField: {},
        params: [],
      }, authInfo: {
        api: urls.kUrlAuditAuthInfo,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
      auditMethodListByPage: {
        api: urls.kUrlWorkflowAuditMethodListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateLeave: {
        api: urls.kUrlUpdateLeave,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      submitWorkflow: {
        api: urls.kUrlSubmitWorkflowLeave,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'node',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlNodeList,
        methodType: 'GET',
        returnField: {},
        params: ['procDefId'],
      },
      getAuth: {
        api: urls.kUrlNodeGetAuth,
        methodType: 'GET',
        returnField: {},
        params: ['nodeId', 'auditId'],
      },
      saveAuth: {
        api: urls.kUrlNodeSaveAuth,
        methodType: 'POST',
        returnField: {},
        params: ['nodeId'],
      },
    },
    initData: {}
  },
  {
    businessName: 'procinsRun',
    modelType: 'entity',
    action: {
      runListByPage: {
        api: urls.kUrlProcinsRunListByPage, methodType: 'GET',
        returnField: {},
        params: [],
      },
      updateSuspensionState: {
        api: urls.kUrlUpdateProcinsSuspensionState,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'procinsEnd',
    modelType: 'entity',
    action: {
      endListByPage: {
        api: urls.kUrlProcinsEndListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'procTaskTodo',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlProcTaskTodoListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      outComeList: {
        api: urls.kUrlProcTaskOutComeList,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      audit: {
        api: urls.kUrlProcTaskAudit,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      flow: {
        api: urls.kUrlProcTaskFlowListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'auditInfo',
    modelType: 'entity',
    action: {
      flowListByPage: {
        api: urls.kUrlAuditInfoFlowListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      businessAuditInfoList: {
        api: urls.kUrlAuditInfobusinessAuditInfoList,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      businessAuditInfo: {
        api: urls.kUrlAuditInfobusinessAuditInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      businessInfo: {
        api: urls.kUrlAuditInfoBusinessInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      auditMainInfo: {
        api: urls.kUrlAuditInfoAuditMainInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'procTaskDone',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlProcTaskDoneListByPage,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'applyAudit',
    modelType: 'entity',
    action: {
      doApplyAudit: {
        api: urls.kUrlAuditApplyInfo,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      look: {
        api: urls.kUrlLookAuditInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      batchAudit: {
        api: urls.kUrlBatchAuditApplyInfo,
        methodType: 'PUT',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'applyPlan',
    modelType: 'entity',
    action: {
      queryAdjustPlanList: {
        api: urls.kUrlAdjustPlanList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      listByPage: {
        api: urls.kUrlApplyPlanList,
        methodType: 'GET',
        returnField: {},
        params: ['ids'],
      },
      list: {
        api: urls.kUrlPlanList,
        methodType: 'GET',
        returnField: {},
        params: ['ids'],
      },
      addPlan: {
        api: urls.kUrlApplyPlanAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updatePlan: {
        api: urls.kUrlApplyPlanUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      deletePlan: {
        api: urls.kUrlApplyPlanDelete,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      enablePlan: {
        api: urls.kUrlApplyPlanEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      planPageList: {
        api: urls.kUrlPlanPageList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      exportStudentGrades: {
        api: urls.kUrlExportApplyStudentGrades,
        methodType: 'GET',
        returnField: {},
        params: [],
      }
    },
    initData: {}
  },
  {
    businessName: 'apply',
    modelType: 'entity',
    action: {
      surveyAnswerList: {
        api: urls.kUrlApplySurveyAnswerList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      syncUpdatePlan: {
        api: urls.kUrlSyncUpdatePlan,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
      queryApplyStudentRecordPage: {
        api: urls.kUrlApplyStudentRecordPage,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      enable: {
        api: urls.kUrlApplyChangeState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      batchCancelledApplyRecord: {
        api: urls.kUrlBatchCancelledApplyRecord,
        methodType: 'PUT',
        params: ['ids'],
        returnField: {},
      },
      deleteApplyRecord: {
        api: urls.kUrlApplyStudentDelete,
        methodType: 'DELETE',
        params: [],
        returnField: {},
      },
      importApplyStudent: {
        api: urls.kUrlApplyRecordImport,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      addApplyStudent: {
        api: urls.kUrlApplyRecordAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      recordPageList: {
        api: urls.kUrlApplyRecordList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      listByPage: {
        api: urls.kUrlApplyListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlApplyAddApply,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlApplyUpdateApply,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlApplyDeleteApply,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      export: {
        api: urls.kUrlApplyExportApply,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      createApplyPlans: {
        api: urls.kUrlCreateApplyPlans,
        methodType: 'POST',
        returnField: {},
        params: ['applyId', 'plans'],
      },
      updateApplyPlans: {
        api: urls.kUrlUpdateApplyPlans,
        methodType: 'PUT',
        returnField: {},
        params: ['applyId', 'plans'],
      },
      getApplyInfo: {
        api: urls.kUrlGetApplyInfo,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      targetScopeInfo: {
        api: urls.kUrlApplyTargetScopeInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      authInfo: {
        api: urls.kUrlApplyAuthInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      saveAuth: {
        api: urls.kUrlApplySaveAuth,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      verifyList: {
        api: urls.kUrlApplyVerifyList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      verifyInfo: {
        api: urls.kUrlApplyPrep,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      verifyDelete: {
        api: urls.kUrlDeleteAuditApply,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      exportVerify: {
        api: urls.kUrlExportAuditApply,
        methodType: 'GET',
        returnField: {},
        params: [],
      }
    },
    initData: {}
  }, { //远程认证 旧平台
    businessName: 'remoteAuth',
    modelType: 'entity',
    action: {
      export: {
        api: urls.kUrlRemoteAuthListExport,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByPage: {
        api: urls.kUrlRemoteAuthListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      import: {
        api: urls.kUrlRemoteAuthImportNew,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      add: {
        api: urls.kUrlRemoteAuthAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlRemoteAuthUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      getRemoteAuthPositionConfig: {
        api: urls.kUrlRemoteAuthPositionConfig,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getRemoteAuthConfigPersonInfoList: {
        api: urls.kUrlRemoteAuthConfigPersonInfoList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: { data: [] }
  },
  { //远程认证详情 旧平台
    businessName: 'studentRemoteAuthDetailOfList',
    modelType: 'entity',
    action: {
      getStudentExamPaper: {
        api: urls.kUrlGetStudentExamPaper,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      changeStudentExamPaper: {
        api: urls.kUrlChangeStudentExamPaper,
        methodType: 'PUT',
        returnField: {}, params: []
      },
    },
    initData: { data: [] }
  },
  { //远程认证详情 旧平台
    businessName: 'studentRemoteAuthDetail',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlStudentRemoteAuthDetailListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      publishState: {
        api: urls.kUrlStudentRemoteAuthDetailPublishState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      publishStateRe: {
        api: urls.kUrlStudentRemoteAuthDetailPublishStateRe,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      setStudentRemoteAuthOwnerId: {
        api: urls.kUrlSetStudentRemoteAuthOwnerId,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      batchUpdateStudentRemoteAuth: {
        api: urls.kUrlBatchUpdateStudentRemoteAuthDetail,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      checkStudentRemoteAuthResources: {
        api: urls.kUrlGetCheckStudentRemoteAuthResources,
        methodType: 'PUT',
        params: ['startDate', 'endDate'],
        returnField: {},
      },
      getStudentRemoteAuthExamInfo: {
        api: urls.kUrlGetStudentRemoteAuthExamInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      saveStudentExamPaper: {
        api: urls.kUrlSaveStudentExamPaper,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      updateAuthState: {
        api: urls.kUrlUpdateAuthState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      remoteAuthReport: {
        api: urls.kUrlRemoteAuthReport,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      list: {
        api: urls.kUrlStudentRemoteAuthDetailList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getStudentRemoteAuthVideo: {
        api: urls.kUrlGetStudentRemoteAuthVideo,
        methodType: 'GET',
        params: ['personId', 'ownerId'],
        returnField: {}
      },
      exportRemoteAuthInfo: {
        api: urls.kUrlExportRemoteAuthInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      importScore: {
        api: urls.kUrlRemoteAuthImportScore,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      importScoreRe: {
        api: urls.kUrlRemoteAuthImportScoreRe,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
    },
    initData: { data: [] }
  },
  { //NEV认证详情
    businessName: 'nevRemoteAuthDetail',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlNevRemoteAuthDetailByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlNevRemoteAuthDetailByList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getNevRemoteAuthDetailExamInfo: {
        api: urls.kUrlNevRemoteAuthDetailExamInfo,
        methodType: 'GET',
        params: ['id'],
        returnField: {}
      },
      saveNevExamPaper: {
        api: urls.kUrlSaveNevExamPaper,
        methodType: 'PUT',
        params: ['id','personId','remoteAuthId','examId'],
        returnField: {},
      },
      batchConfigNevRemoteAuthDetail: {
        api: urls.kUrlBatchConfigNevRemoteAuthDetail,
        methodType: 'POST',
        params: ['ids','remoteAuthId','classAideId','lectureIdList','authDate','startDate','endDate'],
        returnField: {},
      },
      competencyCertificationModel: {
        api: urls.kUrlCompetencyCertificationModel,
        methodType: 'GET',
        params: ['id'],
        returnField: {}
      }
    },
    initData: { data: [] }
  },
  { //远程认证上传文件关联
    businessName: 'fileRemoteAuthRelation',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlFileRemoteAuthRelationList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: { data: [] }
  },
  { //远程认证 保存成绩
    businessName: 'studentModuleRelation',
    modelType: 'entity',
    action: {
      save: {
        api: urls.kUrlModuleRelationSave,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      changeModuleState: {
        api: urls.kUrlChangeModuleState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  { //远程评估
    businessName: 'remoteAssessment',
    modelType: 'entity',
    action: {
      assessmentExamPaper: {
        api: urls.kUrlRemoteAssessmentExamPaper,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      changeAssessmentExamPaper: {
        api: urls.kUrlChangeAssessmentExamPaper,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
      updateAssessmentState: {
        api: urls.kUrlUpdateAssessmentState,
        methodType: 'PUT',
        params: [],
        returnField: {}
      }
    },
    initData: { data: [] }
  },
  { //远程评估
    businessName: 'remoteAssessmentPaper',
    modelType: 'entity',
    action: {
      updateAssessmentPaper: {
        api: urls.kUrlUpdateAssessmentPaper,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
    },
    initData: { data: [] }
  },  //路径相关
  {
    businessName: 'trainPathStage',
    modelType: 'entity',
    action: {
      stageList: {
        api: urls.kUrlTrainPathStageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      stageListPage: {
        api: urls.kUrlTrainPathStageListPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      stageListPageOnScoreRule: {
        api: urls.kUrlTrainPathStageListPageOnScoreRule,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTrainPathStageAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlTrainPathStageUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      getPathInfo: {
        api: urls.kUrlTrainPathStageGetPathInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      sort: {
        api: urls.kUrlTrainPathStageSort,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlTrainPathStageDelete,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      closeOrRelease: {
        api: urls.kUrlTrainPathStageCloseOrRelease,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      getStudentPathList: {
        api: urls.kUrlTrainPathStageGetStudentPathList,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      getStudentPathInfo: {
        api: urls.kUrlTrainPathStageGetStudentPathInfo,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      getCommentStudentPathInfo: {
        api: urls.kUrlTrainPathStageGetCommentStudentPathInfo,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'trainPath',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlGetTrainPath,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTrainPathAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlTrainPathUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateState: {
        api: urls.kUrlTrainPathUpdateState,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      del: {
        api: urls.kUrlTrainPathDel,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      exportTrainPathInfo: {
        api: urls.kUrlTrainPathExportInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      getPathContent: {
        api: urls.kUrlTrainPathExportContent,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      importFile: {
        api: urls.kUrlTrainPathFileImport,
        methodType: 'POST',
        returnField: {},
        headers: {
          'content-type': 'application/json;charset=utf-8',
          'access-control-allow-origin': '*',
          'access-control-allow-methods': 'get,post,put,delete,options',
          'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
          'access-control-max-age': '36000',
          'access-control-allow-credentials': 'true'
        },
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'trainPathTask',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlTrainPathTaskList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTrainPathTaskAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateState: {
        api: urls.kUrlTrainPathTaskUpdateState,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      del: {
        api: urls.kUrlTrainPathTaskDel,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      updateSort: {
        api: urls.kUrlTrainPathTaskUpdateSort,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateSortAll: {
        api: urls.kUrlTrainPathTaskUpdateSortAll,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlTrainPathTaskUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      getTrainPathCommentStageInfo: {
        api: urls.kUrlGetTrainPathCommentStageInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  }, {//阶段成绩计算规则
    businessName: 'trainPathStageScoreRule',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlTrainPathStageScoreRulePageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTrainPathStageScoreRuleAdd,
        methodType: 'POST',
        returnField: {}, params: []
      },
      upd: {
        api: urls.kUrlTrainPathStageScoreRuleUpd,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      del: {
        api: urls.kUrlTrainPathStageScoreRuledel,
        methodType: 'DELETE',
        returnField: {}, params: []
      },
      enable: {
        api: urls.kUrlTrainPathStageScoreRuleEnable,
        methodType: 'POST',
        returnField: {}, params: []
      }

    },
    initData: {}
  },{
    businessName: 'trainPathCommentManagement',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlGetTrainPathCommentPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      list: {
        api: urls.kUrlGetTrainPathCommentList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTrainPathCommentAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlTrainPathCommentUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateState: {
        api: urls.kUrlTrainPathCommentUpdateState,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlTrainPathCommentDel,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      targetScopeInfo: {
        api: urls.kUrlTrainPathCommentTargetScopeInfo,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
    },
    initData: {}
  },
  {
    businessName: 'studentCommentManagement',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlGetStudentCommentPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      list: {
        api: urls.kUrlGetStudentCommentList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlStudentCommentAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlStudentCommentUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateState: {
        api: urls.kUrlStudentCommentUpdateState,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlStudentCommentDel,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      selectOneById: {
        api: urls.kUrlStudentCommentSelectOneById,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      export: {
        api: urls.kUrStudentCommentExport,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'studentCommentDetailManagement',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlGetStudentCommentDetailPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      list: {
        api: urls.kUrlGetStudentCommentDetailList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlStudentCommentDetailAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlStudentCommentDetailUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlStudentCommentDetailDel,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      selectOneById: {
        api: urls.kUrlStudentCommentDetailSelectOneById,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
    },
    initData: {}
  }, {
    businessName: 'noticeTemplate',
    modelType: 'entity',
    action: {
      noticeInfoList: {
        api: urls.kUrlGetNoticeInfoList,
        methodType: 'POST',
        returnField: {}, params: []
      },
      voiceMsgListByPage: {
        api: urls.kUrlVoiceMsgListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      saveNoticeDefine: {
        api: urls.kUrlSaveNoticeDefine,
        methodType: 'POST',
        returnField: {}, params: []
      },
      taskNoticeInfoList: {
        api: urls.kUrlGetTaskNoticeInfoList,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      saveTaskNoticeDefine: {
        api: urls.kUrlSaveTaskNoticeDefine,
        methodType: 'POST',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'trainPathCommentDetailedManagement',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlGetTrainPathCommentDetailedPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      list: {
        api: urls.kUrlGetTrainPathCommentDetailedList,
        methodType: 'GET',
        returnField: {}, params: []
      }
    },
    initData: {}
  }, {
    businessName: 'applicationColumn',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlApplicationColumnPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlApplicationColumnList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      visitList: {
        api: urls.kUrlApplicationColumnVisitPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      visitExport: {
        api: urls.kUrlApplicationColumnVisitList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      chooseList: {
        api: urls.kUrlApplicationColumnChoosePageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      chooseExport: {
        api: urls.kUrlApplicationColumnChooseList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      enable: {
        api: urls.kUrlApplicationColumnEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlApplicationColumnAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlApplicationColumnUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  },
  {
    businessName: 'applyTargetScopeInfo',
    modelType: 'entity',
    action: {
      targetScopeInfo: {
        api: urls.kUrlApplyTargetScopeInfo,
        methodType: 'GET',
        returnField: {}, params: [],
      }
    },
    initData: {},
  },
  {
    businessName: 'applyGetApplyInfo',
    modelType: 'entity',
    action: {
      getApplyInfo: {
        api: urls.kUrlGetApplyInfo,
        methodType: 'GET',
        returnField: {},
        params: [],
      }
    },
    initData: {},
  },
  {
    businessName: 'applyRecordPageList',
    modelType: 'entity',
    action: {
      recordPageList: {
        api: urls.kUrlApplyRecordList,
        methodType: 'GET',
        returnField: {},
        params: [],
      }
    },
    initData: {},
  },
  {
    businessName: 'applicationManage',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlApplicationManagePageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlApplicationManageList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      enable: {
        api: urls.kUrlApplicationManageEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlApplicationManageAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlApplicationManageUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  },
  { //证书
    businessName: 'cert',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlCertListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlCertAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlCertUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateState: {
        api: urls.kUrlCertUpdateState,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlCertDelete,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      export: {
        api: urls.kUrlCertExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      queryPersonInfo: {
        api: urls.kUrlCertQueryPersonInfo,
        methodType: 'GET',
        returnField: {}, params: ['id']
      }
    },
    initData: {},
  },
  { //证书路径阶段配置
    businessName: 'certStage',
    modelType: 'entity',
    action: {
      getPageList: {
        api: urls.kUrlCertStagePageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlCertStageAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlCertStageUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateState: {
        api: urls.kUrlCertStageUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlCertStageDelete,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      export: {
        api: urls.kUrlCertStageList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      getOneInfo: {
        api: urls.kUrlCertStageGetInfo,
        methodType: 'GET',
        returnField: {}, params: ['id']
      }
    },
    initData: {},
  },
  {
    businessName: 'invitation',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlInvitationPageList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlInvitationList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlInvitationAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlInvitationDelete,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      topicEnable: {
        api: urls.kUrlInvitationEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      popularEnable: {
        api: urls.kUrlInvitationEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  },
  { //个人证书
    businessName: 'certRecord',
    modelType: 'entity',
    action: {
      getPageList: {
        api: urls.kUrlCertRecordController,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlCertRecordAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlCertRecordUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlCertRecordExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
      exportNew: {
        api: urls.kUrlCertRecordExportByUserIdentity,
        methodType: 'GET',
        returnField: {}, params: []
      },
      exportDetailFile: {
        api: urls.kUrlCertRecordExportDetailFile,
        methodType: 'GET',
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        returnField: {}, params: []
      },
      exportDetailByIdentityFile: {
        api: urls.kUrlCertRecordExportDetailByIdentityFile,
        methodType: 'GET',
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        returnField: {}, params: []
      },
      importFile: {
        api: urls.kUrlCertRecordImportFile,
        methodType: 'POST',
        returnField: {},
        headers: {
          'content-type': 'application/json;charset=utf-8',
          'access-control-allow-origin': '*',
          'access-control-allow-methods': 'get,post,put,delete,options',
          'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
          'access-control-max-age': '36000',
          'access-control-allow-credentials': 'true'
        },
        params: [],
      },
      updateState: {
        api: urls.kUrlCertRecordUpdateState,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      postConfirm: {
        api: urls.kUrlCertPostConfirm,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  },
  { //个人证书申请
    businessName: 'certApply',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlCertApplyListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      batchUpdate: {
        api: urls.kUrlBatchUpdateCertApply,
        methodType: 'PUT',
        returnField: {},
        params: ['ids', 'checkState', 'checkOpinion'],
      }, getCertApplyInfoById: {
        api: urls.kUrlGetCertApplyInfoById,
        methodType: 'GET',
        returnField: {}, params: ['id', 'next']
      },
      check: {
        api: urls.kUrlCertApplyCheck,
        methodType: 'PUT',
        returnField: {}, params: ['id', 'checkState']
      },
      batchCheck: {
        api: urls.kUrlCertApplyBatchCheck,
        methodType: 'PUT',
        returnField: {}, params: []
      },
    },
    initData: {},
  },
  { //证书挂靠
    businessName: 'certLink',
    modelType: 'entity',
    action: {
      getPageList: {
        api: urls.kUrlCertLinkRelationList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getList: {
        api: urls.kUrlCertLinkRelationGetList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      updateOrg: {
        api: urls.kUrlCertLinkRelationUpdateOrg,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateLinkState: {
        api: urls.kUrlCertLinkRelationUpdateLinkState,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      importFile: {
        api: urls.kUrlCertLinkRelationImportFile,
        methodType: 'POST',
        returnField: {},
        headers: {
          'content-type': 'application/json;charset=utf-8',
          'access-control-allow-origin': '*',
          'access-control-allow-methods': 'get,post,put,delete,options',
          'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
          'access-control-max-age': '36000',
          'access-control-allow-credentials': 'true'
        },
        params: [],
      },
      getOrgIdList: {
        api: urls.kUrlCertLinkRelationGetOrgIdList,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {},
  },
  {
    businessName: 'activity',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlActivityPageList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlActivityList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlActivityAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlActivityUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      enable: {
        api: urls.kUrlActivityEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      look: {
        api: urls.kUrlActivityLook,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      participateExport: {
        api: urls.kUrlActivityParticipateExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  }, {
    businessName: 'activityTopic',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlActivityTopicList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      create: {
        api: urls.kUrlCreateActivityTopic,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      enable: {
        api: urls.kUrlActivityTopicEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      }
    },
    initData: {},
  },
  {
    businessName: 'comment',
    modelType: 'entity',
    action: {
      batchReviewPre: {
        api: urls.kUrlCommentBatchReviewPre,
        methodType: 'GET',
        returnField: {}, params: []
      },
      reviewComment: {
        api: urls.kUrlCommentReview,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      shortVideoCommentPageList: {
        api: urls.kUrlShortVideoCommentPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      shortVideoCommentList: {
        api: urls.kUrlShortVideoCommentList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      listByPage: {
        api: urls.kUrlCommentPageList,
        methodType: 'POST',
        returnField: {}, params: []
      },
      commentMarkDetailPageList: {
        api: urls.kUrlCommentMarkDetailPageList,
        methodType: 'POST',
        returnField: {}, params: []
      },
      changeTop: {
        api: urls.kUrlCommentChangeTop,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      changeScreen: {
        api: urls.kUrlCommentChangeScreen,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      changeScreenBatch: {
        api: urls.kUrlCommentChangeScreenBatch,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlCommentExport,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  },
  {
    businessName: 'operateRecord',
    modelType: 'entity',
    action: {
      shortVideoOperatePageList: {
        api: urls.kUrlShortVideoOperateRecordPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      shortVideoOperateList: {
        api: urls.kUrlShortVideoOperateRecordList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlOperateRecordPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlOperateRecordAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      export: {
        api: urls.kUrlOperateRecordExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
      operateRecordUserPageList: {
        api: urls.kUrlOperateRecordUserPageList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      operateRecordUserList: {
        api: urls.kUrlOperateRecordUserList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: {},
  }, {
    businessName: 'activityPart',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlActivityPartPageList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlActivityPartList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlActivityPartAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlActivityPartUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      enable: {
        api: urls.kUrlActivityPartEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      look: {
        api: urls.kUrlActivityPartLook,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      participateExport: {
        api: urls.kUrlActivityPartParticipateExport,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  },
  { //系列化
    businessName: 'series',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlSeriesPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlSeriesAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      export: {
        api: urls.kUrlGetSeriesList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getSeriesInfo: {
        api: urls.kUrlGetSeriesInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      update: {
        api: urls.kUrlSeriesUpd,
        methodType: 'PUT',
        params: ['id'],
        returnField: {},
      },
      updateStatus: {
        api: urls.kUrlUpdateState,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      exportFollowRecord: {
        api: urls.kUrlExportFollowRecord,
        methodType: 'GET',
        returnField: {}, params: []
      },
      exportSeriesStudyDetail: {
        api: urls.kUrlExportSeriesStudyDetail,
        methodType: 'GET',
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        returnField: {}, params: []
      },
      exportSeriesStudyReport: {
        api: urls.kUrlExportSeriesStudyReport,
        methodType: 'GET',
        requestConfig: {
          responseType: 'blob',
          endpoint: 'admin'
        },
        returnField: {}, params: []
      },
      importFile: {
        api: urls.kUrlSeriesImport,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
    },
    initData: {},
  }, {
    businessName: 'activityMessage',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlActivityMessagePageList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlActivityMessageAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlActivityMessageUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      enable: {
        api: urls.kUrlActivityMessageEnable,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      look: {
        api: urls.kUrlActivityMessageLook,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {},
  }, { //系列化关联课程
    businessName: 'seriesProgram',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlGetSeriesProgramPageList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlSeriesProgramAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlSeriesProgramUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlExportSeriesProgram,
        methodType: 'GET',
        returnField: {}, params: []
      }
    },
    initData: {},
  },   //内容管理
  {
    businessName: 'contentRecord',
    modelType: 'entity',
    action: {
      export: {
        api: urls.kUrlContentRecordList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      listByPage: {
        api: urls.kUrlContentRecordPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      learningMaterialRecordExport: {
        api: urls.kUrlLearningMaterialRecordExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
    }, initData: {}
  },
  {
    businessName: 'contentManage',
    modelType: 'entity',
    action: {
      enable: {
        api: urls.kUrlContentEnable,
        methodType: 'PUT',
        returnField: {}, params: [],
      },
      changeTop: {
        api: urls.kUrlContentChangeTop,
        methodType: 'PUT',
        returnField: {}, params: [],
      },
      delete: {
        api: urls.kUrlContentDelete,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlContentExport,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      listByPage: {
        api: urls.kUrlGetContentInfoList,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlContentAdd,
        methodType: 'POST',
        returnField: {}, params: [],
      },
      upd: {
        api: urls.kUrlContentUpd,
        methodType: 'PUT',
        returnField: {}, params: [],
      },
      detailInfo: {
        api: urls.kUrlContentDetailInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    }, initData: {}
  },
  {
    businessName: 'addContentRecord',
    modelType: 'entity',
    action: {
      add: {
        api: urls.kUrlAddContentRecord,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'contentLabel',
    modelType: 'entity',
    action: {
      shortVideoLabelPageList: {
        api: urls.kUrlShortVideoLabelListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      import: {
        api: urls.kUrlImportLabelInfo,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
      export: {
        api: urls.kUrlExportLabelInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      listByPage: {
        api: urls.kUrlLabelListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      nodeList: {
        api: urls.kUrlLabelNodeList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      add: {
        api: urls.kUrlAddLabel,
        methodType: 'POST',
        params: ['title', 'orderNo', 'typeIds'],
        returnField: {},
      },
      upd: {
        api: urls.kUrlUpdLabel,
        methodType: 'PUT',
        params: ['id', 'title', 'orderNo', 'typeIds'],
        returnField: {},
      },
      del: {
        api: urls.kUrlDelLabel,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      enable: {
        api: urls.kUrlEnableLabel,
        methodType: 'PUT',
        params: ['ids', 'state'],
        returnField: {},
      },
    },
    initData: {}
  },   //远程评估视频列表
  {
    businessName: 'video',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlGetPlayList,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  }, { //互动直播
    businessName: 'interactLive',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlInteractListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      syncLiveRecord: {
        api: urls.kUrlLiveRecordSyncRecord,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
      add: {
        api: urls.kUrlAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdate,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      delete: {
        api: urls.kUrlDeleteInteractLive,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      getInfo: {
        api: urls.kUrlGetInteractLiveInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      setInteractLiveState: {
        api: urls.kUrlSetInteractLiveState,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      exportLiveAuthInfo: {
        api: urls.kUrlExportLiveAuthInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlExportLive,
        methodType: 'GET',
        returnField: {}, params: []
      },
      hostListByPage: {
        api: urls.kUrlInteractHostListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getWebLiveUrl: {
        api: urls.kUrlGetWebLiveUrl,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getWebUploadBackPlayUrl: {
        api: urls.kUrlGetWebUploadBackPlayUrl,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getLiveRoomInfo: {
        api: urls.kUrlGetLiveRoomInfo,
        methodType: 'GET',
        returnField: {}, params: ['id']
      },
      getInteractLiveRecordVideo: {
        api: urls.kUrlGetInteractLiveRecordVideo,
        methodType: 'GET',
        returnField: {}, params: ['ownerId']
      },
      addInteractLive: {
        api: urls.kUrlAddInteractLive,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateInteractLive: {
        api: urls.kUrlUpdateInteractLive,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      selectInteractLiveDetailInfo: {
        api: urls.kUrlSelectInteractLiveDetailInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      checkMeetingDate: {
        api: urls.kUrlCheckMeetingDate,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getInteractLiveTimes: {
        api: urls.kUrlGetInteractLiveTimes,
        methodType: 'GET',
        returnField: {}, params: ['id']
      },
      exportInteractLiveRecordDetail: {
        api: urls.kUrlExportInteractLiveRecordDetail,
        methodType: 'GET',
        returnField: {}, params: ['id']
      },
    },
    initData: {}
  },
  { //资源帐户管理
    businessName: 'interactLiveResources',
    modelType: 'entity',
    action: {
      entityByPage: {
        api: urls.kUrlInteractLiveResourcesByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      entityByList: {
        api: urls.kUrlInteractLiveResourcesByList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      entityByOne: {
        api: urls.kUrlInteractLiveResourcesById,
        methodType: 'GET',
        returnField: {}, params: ['id']
      },
      batchCreateZoomUserResources: {
        api: urls.kUrlBatchCreateZoomUserResources,
        methodType: 'POST',
        returnField: {}, params: ['userType','type','resourcesCount']
      },
      batchSyncUserResourcesUserType: {
        api: urls.kUrlBatchSyncUserResourcesUserType,
        methodType: 'POST',
        returnField: {}, params: []
      },
      updateResourcesState: {
        api: urls.kUrlInteractLiveResourcesUpdateState,
        methodType: 'PUT',
        returnField: {}, params: ['idList']
      }
    },
    initData: {}
  },
  { //正常经销商
    businessName: 'normalDealer',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlNormalDealerListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlAddNormalDealer,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlDeleteNormalDealer,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      import: {
        api: urls.kUrlImportNormalDealer,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlExportNormalDealer,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  { //考核经销商规则
    businessName: 'dealerRule',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlGetDealerRuleListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      importFile: {
        api: urls.kUrlDealerRuleImportFile,
        methodType: 'POST',
        returnField: {},
        params: [],
        requestConfig: {
          headers: {
            'content-type': 'application/json;charset=utf-8',
            'access-control-allow-origin': '*',
            'access-control-allow-methods': 'get,post,put,delete,options',
            'access-control-allow-headers': 'authorization,content-type,accept,x-requested-with,sid,mycustom,smuser,origin',
            'access-control-max-age': '36000',
            'access-control-allow-credentials': 'true',
            endpoint: 'admin'
          }
        }
      },
    },
    initData: {}
  },
  { //经销商规模规则
    businessName: 'scaleRule',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlGetScaleRuleList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlAddScaleRule,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdateScaleRule,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      delete: {
        api: urls.kUrlDeleteScaleRule,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
    },
    initData: {}
  },
  { //岗位组规则
    businessName: 'positionRule',
    modelType: 'entity',
    action: {
      import: {
        api: urls.kUrlImportPositionRule,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      list: {
        api: urls.kUrlGetPositionRuleList,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },
  { //规则匹配
    businessName: 'ruleConfigure',
    modelType: 'entity',
    action: {
      editInfo: {
        api: urls.kUrlGetRuleConfigureEditInfo,
        methodType: 'GET',
        returnField: {}, params: ['id']
      },
      recordInfo: {
        api: urls.kUrlGetRuleConfigureRecordInfo,
        methodType: 'GET',
        returnField: {}, params: ['id']
      }, list: {
        api: urls.kUrlGetRuleConfigureList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlAddRuleConfigure,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdRuleConfigure,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      }, enable: {
        api: urls.kUrlEnableRuleConfigure,
        methodType: 'PUT',
        params: ['ids', 'state'],
        returnField: {},
      },
    },
    initData: {}
  },   //互动直播   参训记录
  {
    businessName: 'liveStatistics',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlLiveStatisticsListByPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      syncLiveRecord: {
        api: urls.kUrlLiveRecordSyncRecord,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
      export: {
        api: urls.kUrlExportLiveStatistics,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlAddLiveStatistics,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdLiveStatistics,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      delete: {
        api: urls.kUrlDeleteLiveStatistics,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      updateTrainingStatistics: {
        api: urls.kUrlSyncCalculationTrainReport,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
    },
    initData: {}
  },
  {
    businessName: 'statisticsRule',
    modelType: 'entity',
    action: {
      selectOneById: {
        api: urls.kUrlStatisticsRuleSelectOneById,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      add: {
        api: urls.kUrlAddLiveStatistics,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlUpdLiveStatistics,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      syncRecord: {
        api: urls.kUrlSyncRecord,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
    },
    initData: {}
  },
  //科目管理
  {
    businessName: 'subject',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlSubjectGetPageList,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      exportLiveStatistics: {
        api: urls.kUrlExportLiveStatistics,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      add: {
        api: urls.kUrlSubjectAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlSubjectUpd,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      del: {
        api: urls.kUrlSubjectDel,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      updateState: {
        api: urls.kUrlSubjectUpdateState,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      getInfoById: {
        api: urls.kUrlSubjectGetInfoById,
        methodType: 'GET',
        returnField: {}, params: []
      },
      exportHomeworkRecordExport: {
        api: urls.kUrlHomeworkRecordControllerExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
      queryPersonInfo: {
        api: urls.kUrlSubjectQueryPersonInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      queryOrgInfo: {
        api: urls.kUrlSubjectQueryQueryOrgInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },   //科目学分记录管理
  {
    businessName: 'subjectCreditRecord',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlSubjectCreditRecordSubjectCreditDealerRecordPage,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      upd: {
        api: urls.kUrlSubjectCreditRecordUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlSubjectCreditRecordAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      updateState: {
        api: urls.kUrlSubjectCreditRecordUpdateState,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      getDealerById: {
        api: urls.kUrlSubjectCreditRecordGetDealerById,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      import: {
        api: urls.kUrlSubjectCreditRecordImport,
        methodType: 'PUT',
        returnField: {}, params: [],
      },
      personExport: {
        api: urls.kUrlSubjectCreditPersonRecordExport,
        methodType: 'GET',
        returnField: {}, params: [],
      },
      dealerExport: {
        api: urls.kUrlSubjectCreditDealerRecordExport,
        methodType: 'GET',
        returnField: {}, params: [],
      },
    },
    initData: {}
  },
  { //作业管理
    businessName: 'homework',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlHomeworkListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlAddHomework,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdateHomework,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      delete: {
        api: urls.kUrlDeleteHomework,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      getInfo: {
        api: urls.kUrlGetHomeworkInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      updateState: {
        api: urls.kUrlsetHomeworkState,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      export: {
        api: urls.kUrlExportHomework,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },
  { //作业记录管理
    businessName: 'homeworkRecord',
    modelType: 'entity',
    action: {
      batchAudit: {
        api: urls.kUrlHomeworkRecordControllerBatchAudit,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      pageList: {
        api: urls.kUrlHomeworkRecordControllerListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getReviewPageList: {
        api: urls.kUrlHomeworkRecordControllerReviewListByPage,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getInfo: {
        api: urls.kUrlHomeworkRecordControllerGetInfoById,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
      getResultInfo: {
        api: urls.kUrlHomeworkRecordControllerGetResultInfoById,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
      reviewResultNext: {
        api: urls.kUrlHomeworkRecordControllerReviewResultNext,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      reviewResult: {
        api: urls.kUrlHomeworkRecordControllerReviewResult,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      review: {
        api: urls.kUrlHomeworkRecordControllerReview,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      reviewCheck: {
        api: urls.kUrlHomeworkRecordControllerReviewCheck,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      export: {
        api: urls.kUrlHomeworkRecordControllerExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
      exportReview: {
        api: urls.kUrlHomeworkRecordControllerExportReview,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  { //审核-报名详情
    businessName: 'auditApplyDetail',
    modelType: 'entity',
    action: {
      getDetail: {
        api: urls.kUrlAuditInfoAuditMainInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'authPerson',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlAuthPersonListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'taskInfo',
    modelType: 'entity',
    action: {
      taskList: {
        api: urls.kUrlTaskInfoList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      listByPage: {
        api: urls.kUrlTaskInfoListByPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      enable: {
        api: urls.kUrlTaskInfoEnable,
        methodType: 'PUT',
        returnField: {}, params: []
      },
      editInfo: {
        api: urls.kUrlTaskInfoEditInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTaskInfoAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlTaskInfoUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'taskRecord',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlTaskRecordListByPage,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlTaskRecordListExport,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'coursewareManagement',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlCoursewarePageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlCoursewareAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      upd: {
        api: urls.kUrlCoursewareUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      selectOneById: {
        api: urls.kUrlCoursewareSelectOneById,
        methodType: 'GET',
        returnField: {}, params: ['id'],
      },
    },
    initData: {}
  },
  {
    businessName: 'version',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlVersionListByPage,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      create: {
        api: urls.kUrlCreateVersion,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      update: {
        api: urls.kUrlUpdateVersion,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      findVersionById: {
        api: urls.kUrlFindVersionById,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      delete: {
        api: urls.kUrlDeleteVersion,
        methodType: 'DELETE',
        returnField: {},
        params: ['id']
      }
    },
    initData: { data: {} }
  },
  {
    businessName: 'commonConfig',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlCommonConfigPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlCommonConfigAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlCommonConfigUpdate,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      enable: {
        api: urls.kUrlCommonConfigUpdateState,
        methodType: 'PUT',
        returnField: {}, params: ['id'],
      },
      delete: {
        api: urls.kUrlCommonConfigBatchDelete,
        methodType: 'DELETE',
        params: ['ids'],
        returnField: {},
      },
      export: {
        api: urls.kUrlCommonConfigExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'authUserLog',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlAuthUserLogPage,
        methodType: 'GET',
        returnField: {}, params: []
      },
      // export: {
      //   api: urls.kUrlCommonConfigExport,
      //   methodType: 'GET',
      //   params: [],
      //   returnField: {},
      // }
    },
    initData: {}
  },
  {
    businessName: 'audienceGroup',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlAdminDataPermGroupList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      upd: {
        api: urls.kUrlAdminDataPermGroupUpd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      add: {
        api: urls.kUrlAdminDataPermGroupAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      editInfo: {
        api: urls.kUrlAdminDataPermGroupEditInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      // export: {
      //   api: urls.kUrlCommonConfigExport,
      //   methodType: 'GET',
      //   params: [],
      //   returnField: {},
      // }
    },
    initData: {}
  },
  {
    businessName: 'manageAuth',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlAdminDataPermQueryAuthInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      save: {
        api: urls.kUrlAdminDataPermSave,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'examReport',
    modelType: 'entity',
    action: {
      getPageList: {
        api: urls.kUrlExamReportList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListOrg: {
        api: urls.kUrlExamReportListOrg,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListOrgPosition: {
        api: urls.kUrlExamReportListOrgPosition,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlExamReportExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportOrg: {
        api: urls.kUrlExamReportExportOrg,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportOrgPosition: {
        api: urls.kUrlExamReportExportOrgPosition,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'programReport',
    modelType: 'entity',
    action: {
      getPageList: {
        api: urls.kUrlProgramReportList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListProgramOrg: {
        api: urls.kUrlProgramReportListProgramOrg,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListProgram: {
        api: urls.kUrlProgramReportListProgram,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlProgramReportExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportProgramOrg: {
        api: urls.kUrlProgramReportExportProgramOrg,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportProgram: {
        api: urls.kUrlProgramReportExportProgram,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'offlineProgramReport',
    modelType: 'entity',
    action: {
      getPageList: {
        api: urls.kUrlOfflineProgramReportList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListAuth: {
        api: urls.kUrlOfflineProgramReportListAuth,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListProgramOrg: {
        api: urls.kUrlOfflineProgramReportListProgramOrg,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListProgram: {
        api: urls.kUrlOfflineProgramReportListProgram,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlOfflineProgramReportExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportAuth: {
        api: urls.kUrlOfflineProgramReportExportAuth,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportProgramOrg: {
        api: urls.kUrlOfflineProgramReportExportProgramOrg,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportProgram: {
        api: urls.kUrlOfflineProgramReportExportProgram,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      simpleExport: {
        api: urls.kUrlOfflineProgramReportExport,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'certReport',
    modelType: 'entity',
    action: {
      getPageListStudent: {
        api: urls.kUrlCertReportListStudent,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListOrg: {
        api: urls.kUrlCertReportListOrg,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      exportStudent: {
        api: urls.kUrlCertReportExportStudent,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportOrg: {
        api: urls.kUrlCertReportExportOrg,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'pathReport',
    modelType: 'entity',
    action: {
      getPageListTaskDetail: {
        api: urls.kUrlPathReportListTaskDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      exportTaskStudentDetail: {
        api: urls.kUrlPathReportExportTaskDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListScoreDetail: {
        api: urls.kUrlPathReportListScoreComplete,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      exportScoreStudentDetail: {
        api: urls.kUrlPathReportExportScoreComplete,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListStudentDetail: {
        api: urls.kUrlPathReportListStudentDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListStudentComplete: {
        api: urls.kUrlPathReportListStudentComplete,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getPageListOrg: {
        api: urls.kUrlPathReportListOrg,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      exportStudentDetail: {
        api: urls.kUrlPathReportExportStudentDetail,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportStudentComplete: {
        api: urls.kUrlPathReportExportStudentComplete,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      exportOrg: {
        api: urls.kUrlPathReportExportOrg,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'dealerTrainReport',
    modelType: 'entity',
    action: {
      getDealerTrainReportList: {
        api: urls.kUrlDealerTrainReportList,
        methodType: 'GET',
        returnField: {},
        params: ['statisticsRuleId', 'version']
      },
      getDealerTrainReportPage: {
        api: urls.kUrlDealerTrainReportPage,
        methodType: 'GET',
        returnField: {},
        params: ['statisticsRuleId', 'version']
      },
    },
    initData: {}
  },
  {
    businessName: 'positionTrainReport',
    modelType: 'entity',
    action: {
      getPositionTrainReportList: {
        api: urls.kUrlPositionTrainReportList,
        methodType: 'GET',
        returnField: {},
        params: ['statisticsRuleId', 'version']
      },
      getPositionTrainReportPage: {
        api: urls.kUrlPositionTrainReportPage,
        methodType: 'GET',
        returnField: {},
        params: ['statisticsRuleId', 'version']
      },
    },
    initData: {}
  },
  {
    businessName: 'audience',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlAdminDataPermList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'requirement',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetRequirementDetailPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlRequirementDetailAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlRequirementDetailUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlRequirementDetailDel,
        methodType: 'DELETE',
        returnField: {},
        params: [],
      },
      selectRequirementById: {
        api: urls.kUrlRequirementDetailSelectOneById,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      updateState: {
        api: urls.kUrlRequirementDetailUpdateState,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      export: {
        api: urls.kUrlGetRequirementDetailExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'RequirementPartTimePosition',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlRequirementPartTimePositionPageList,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      add: {
        api: urls.kUrlRequirementPartTimePositionPageAdd,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      update: {
        api: urls.kUrlRequirementPartTimePositionPageUpd,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      delete: {
        api: urls.kUrlRequirementPartTimePositionPageDel,
        methodType: 'DELETE',
        params: [],
        returnField: {},
      },
      enable: {
        api: urls.kUrlRequirementPartTimePositionPageEnable,
        methodType: 'POST',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'requirementConfig',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetRequirementConfigPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlRequirementConfigAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlRequirementConfigUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      selectOneById: {
        api: urls.kUrlRequirementConfigSelectOneById,
        methodType: 'GET',
        returnField: {},
        params: ['id'],
      },
      updateState: {
        api: urls.kUrlRequirementConfigUpdateState,
        methodType: 'POST',
        returnField: {},
        params: ['id'],
      },
      export: {
        api: urls.kUrlGetRequirementConfigList,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'requirementRecord',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetRequirementDataPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getList: {
        api: urls.kUrlGetRequirementDataDetailList,
        methodType: 'GET',
        returnField: {}, params: []
      }
    },
    initData: {}
  },

  {
    businessName: 'requirementPersonnel',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetRequirementPersonnelPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getList: {
        api: urls.kUrlGetRequirementPersonnelList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      dealerConfirm: {
        api: urls.kUrlRequirementPersonnelConfirm,
        methodType: 'GET',
        returnField: {}, params: []
      },
      exportTypeReport: {
        api: urls.kUrlRequirementPersonnelExportTypeReport,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },

  {
    businessName: 'requirementPersonnelDetail',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetRequirementPersonnelDetailPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getList: {
        api: urls.kUrlGetRequirementPersonnelDetailList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      saveOrUpdateState: {
        api: urls.kUrlRequirementPersonnelDetailSaveOrUpdateState,
        methodType: 'POST',
        returnField: {}, params: []
      },
      import: {
        api: urls.kUrlRequirementPersonnelDetailImportFile,
        methodType: 'POST',
        returnField: {}, params: []
      },
      getHeadList: {
        api: urls.kUrlGetRequirementPersonnelDetailHeadList,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },

  {
    businessName: 'hostLiveRecord',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlQueryInteractLivePage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      list: {
        api: urls.kUrlQueryInteractLive,
        methodType: 'GET',
        params: [],
        returnField: {},
      }
    },
    initData: { data: [] }
  },
  {
    businessName: 'beforeCondition',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlBeforeConditionDetailInfo,
        methodType: 'GET',
        params: [],
        returnField: {},
      },
      save: {
        api: urls.kUrlBeforeConditionSave,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlBeforeConditionDelete,
        methodType: 'DELETE',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'reportConfig',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetReportConfigPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlReportConfigAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlReportConfigUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      export: {
        api: urls.kUrlExportReportConfigList,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      selectOneById: {
        api: urls.kUrlSelectOneByIdReportConfig,
        methodType: 'GET',
        returnField: {}, params: []
      },
      selectOneDetailById: {
        api: urls.kUrlSelectOneDetailByIdReportConfig,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getDetailListByPage: {
        api: urls.kUrlPageDetailListReportConfig,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getDetailListExport: {
        api: urls.kUrlDetailListReportConfig,
        methodType: 'GET',
        returnField: {}, params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'tableConfig',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetTableConfigPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getList: {
        api: urls.kUrlGetTableConfigList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTableConfigAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlTableConfigUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateTableConfigState: {
        api: urls.kUrlTableConfigUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'tableField',
    modelType: 'entity',
    action: {
      getAllListByPage: {
        api: urls.kUrlGetTableFieldPageAllList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getList: {
        api: urls.kUrlGetTableFieldList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      add: {
        api: urls.kUrlTableFieldAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlTableFieldUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      updateTableFieldState: {
        api: urls.kUrlTableFieldUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'notice',
    modelType: 'entity',
    action: {
      sendNotice: {
        api: urls.kUrlNoticeSendNotice,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'messageNoticeRecord',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlMessageNoticeRecordPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getSceneByType: {
        api: urls.kUrlGetSceneByTypeList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      recordByPage: {
        api: urls.kUrlMessageNoticeRecordDetailPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      recordPic: {
        api: urls.kUrlMessageNoticeRecordDetailPic,
        methodType: 'GET',
        returnField: {},
        params: []
      }
    },
    initData: {}
  }, { //远程认证 旧平台
    businessName: 'orgRemoteAuthDetail',
    modelType: 'entity',
    action: {
      export: {
        api: urls.kUrlExport,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      listByPage: {
        api: urls.kUrlGetListByPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlAddOrgRemoteAuthDetail,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdateOrgRemoteAuthDetail,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      selectOneById: {
        api: urls.kUrlSelectOneById,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      orgRemoteAuthDetailInteractLiveExport: {
        api: urls.kUrlOrgRemoteAuthDetailInteractLiveRecordExport,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      orgRemoteAuthDetailInteractLiveListByPage: {
        api: urls.kUrlOrgRemoteAuthDetailInteractLiveRecordPage,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      importScore: {
        api: urls.kUrlEvaluationImportScore,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      getOrgRemoteAuthExamInfo: {
        api: urls.kUrlGetOrgRemoteAuthExamInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },

    },
    initData: { data: [] }
  }, { //远程认证 旧平台
    businessName: 'authQuestionDetailScore',
    modelType: 'entity',
    action: {
      update: {
        api: urls.kUrlUpdateAuthQuestionDetailScores,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'permissions',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlBizDataPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlBizDataAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'thirdLogin',
    modelType: 'entity',
    action: {
      generateCallBackUrl: {
        api: urls.kUrlGenerateCallBackUrl,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      jumpUrl: {
        api: urls.kUrlJumpUrl,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      getLoginInfo: {
        api: urls.kUrlGetLoginInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'thirdCopr',
    modelType: 'entity',
    action: {

      listByPage: {
        api: urls.kUrlCoprListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddThirdCopr,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdateThirdCopr,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      delete: {
        api: urls.kUrlDeleteThirdCopr,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      list: {
        api: urls.kUrlCoprList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'thirdCorpUser',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlCorpUserListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      list: {
        api: urls.kUrlCorpUserList,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      save: {
        api: urls.kUrlCorpUserSave,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      import: {
        api: urls.kUrlCorpUserImport,
        methodType: 'PUT',
        returnField: {},
        params: [],
      }
    },
    initData: {}
  },
  {
    businessName: 'thirdApp',
    modelType: 'entity',
    action: {

      listByPage: {
        api: urls.kUrlAppListByPage,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
      add: {
        api: urls.kUrlAddThirdApp,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlUpdateThirdApp,
        methodType: 'PUT',
        returnField: {},
        params: ['id'],
      },
      delete: {
        api: urls.kUrlDeleteThirdApp,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      labelInfo: {
        api: urls.kUrlGetLabelInfoThirdApp,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },

  {
    businessName: 'whitelist',
    modelType: 'entity',
    action: {
      authInfo: {
        api: urls.kUrlWhitelistAuthInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      save: {
        api: urls.kUrlWhitelistSave,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
      listPersonInfo: {
        api: urls.kUrlWhitelistPersonInfo,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  {
    businessName: 'cleExam',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlCleExamPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlCleExamList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      save: {
        api: urls.kUrlCleExamSave,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      updateState: {
        api: urls.kUrlCleExamUpdateState,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      exportStudentsAnswers: {
        api: urls.kUrlCleExamStudentsAnswers,
        methodType: 'GET',
        returnField: {},
        params: [],
      },
    },
    initData: {}
  },
  {
    businessName: 'certificateStatistics',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlCertOrgAuthPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlCertOrgAuthListExport,
        methodType: 'GET',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'preAudit',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlPreAuditPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlPreAuditList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlPreAuditAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      import: {
        api: urls.kUrlPreAuditImport,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      downloadList: {
        api: urls.kUrlPreAuditDownloadList,
        methodType: 'GET',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'shortVideo',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlShortVideoPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlShortVideoList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      look: {
        api: urls.kUrlShortVideoInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlShortVideoAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      updateSet: {
        api: urls.kUrlShortVideoUpdateSet,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      operatePageList: {
        api: urls.kUrlShortVideoRecordPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      operateList: {
        api: urls.kUrlShortVideoRecordList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      enable: {
        api: urls.kUrlShortVideoUpdateState,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      delete: {
        api: urls.kUrlShortVideoDelete,
        methodType: 'DELETE',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'personnelTraining',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlPersonnelTrainingPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlPersonnelTrainingList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlPersonnelTrainingAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      update: {
        api: urls.kUrlPersonnelTrainingUpd,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      enable: {
        api: urls.kUrlPersonnelTrainingEnable,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'linchpinKPI',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlKPIPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlKPIList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlKPIAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      enable: {
        api: urls.kUrlKPIEnable,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'satisfaction',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlSatisfactionPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlSatisfactionList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlSatisfactionAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      enable: {
        api: urls.kUrlSatisfactionEnable,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'certificateStatisticsCfg',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlCertCategoryConfigPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlCertCategoryConfigAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      update: {
        api: urls.kUrlCertCategoryConfigUpdate,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      delete: {
        api: urls.kUrlCertCategoryConfigDelete,
        methodType: 'DELETE',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'shortVideoScreen',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlShortVideoScreenPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlShortVideoScreenList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      recordList: {
        api: urls.kUrlShortVideoScreenRecordPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      recordExport: {
        api: urls.kUrlShortVideoScreenRecordList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      toDeal: {
        api: urls.kUrlShortVideoScreenToDeal,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      look: {
        api: urls.kUrlShortVideoScreenLook,
        methodType: 'GET',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'shortVideoPersonRelation',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlShortVideoPersonRelationPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlShortVideoPersonRelationList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'shortVideoMessage',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlShortVideoMessagePageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlShortVideoMessageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'interviewQuestion',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlInterviewQuestionPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlInterviewQuestionList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      import: {
        api: urls.kUrlInterviewQuestionImport,
        methodType: 'POST',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'personalityChecklist',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlPersonalityChecklist,
        methodType: 'GET',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'interviewResume',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlResumeInfoPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlResumeInfoList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      update: {
        api: urls.kUrlResumeUpdate,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      exportResume: {
        api: urls.kUrlExportResumeList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      exportMbti: {
        api: urls.kUrlExportMbtiList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      exportPDF:{
        api:urls.kUrlResumeExportPDF,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      needAgainPageList: {
        api: urls.kUrlResumeInfoNeedAgainPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      resumeApply: {
        api: urls.kUrlResumeApply,
        methodType: 'POST',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'integrationCounseling',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlIntegrationCounselingPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlIntegrationCounselingList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlIntegrationCounselingAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      update: {
        api: urls.kUrlIntegrationCounselingUpd,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      revoke: {
        api: urls.kUrlIntegrationCounselingRevoke,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      teacherList: {
        api: urls.kUrlIntegrationCounselingTeacherList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      remind: {
        api: urls.kUrlIntegrationCounselingListRemind,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      detail: {
        api: urls.kUrlIntegrationCounselingById,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      processRemind: {
        api: urls.kUrlIntegrationCounselingProcessRemind,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      processList: {
        api: urls.kUrlIntegrationCounselingProcessById,
        methodType: 'GET',
        returnField: {},
        params: []
      },

    },
    initData: {}
  },
  {
    businessName: 'counselingProcess',
    modelType: 'entity',
    action: {
      downCriteria: {
        api: urls.kUrlCounselingDownCriteria,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      postPersonnel: {
        api: urls.kUrlCounselingPostPersonnel,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      renewPostPersonnel: {
        api: urls.kUrlCounselingRenewPostPersonnel,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      dealerManager: {
        api: urls.kUrlCounselingDealerManager,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      setDealerManager: {
        api: urls.kUrlCounselingSetDealerManager,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      startNotice: {
        api: urls.kUrlCounselingStartNotice,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      updateStartNoticeState: {
        api: urls.kUrlCounselingUpdateStartNoticeState,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      noticeDetail: {
        api: urls.kUrlCounselingNoticeDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      sendNotice: {
        api: urls.kUrlCounselingSendNotice,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      confirmNotice: {
        api: urls.kUrlCounselingConfirmNotice,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      writeMark: {
        api: urls.kUrlCounselingWriteMark,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      confirmMainPerson: {
        api: urls.kUrlCounselingConfirmMainPerson,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      salesOpening: {
        api: urls.kUrlCounselingSalesOpening,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      salesOpeningDetail: {
        api: urls.kUrlCounselingSalesOpeningDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      salesOpeningAudit: {
        api: urls.kUrlCounselingSalesOpeningAudit,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      confirmSalesOpening: {
        api: urls.kUrlCounselingConfirmSalesOpening,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      callCar: {
        api: urls.kUrlCounselingCallCar,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      callCarDetail: {
        api: urls.kUrlCounselingCallCarDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      callCarCheck: {
        api: urls.kUrlCounselingCallCarCheck,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      confirmCallCar: {
        api: urls.kUrlCounselingConfirmCallCar,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      managerEvaluation: {
        api: urls.kUrlCounselingManagerEvaluation,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      managerEvaluationSave: {
        api: urls.kUrlCounselingManagerEvaluationSave,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      managerEvaluationDetail: {
        api: urls.kUrlCounselingManagerEvaluationDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      confirmManagerEvaluation: {
        api: urls.kUrlCounselingConfirmManagerEvaluation,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      preAuditOrCheckInfo: {
        api: urls.kUrlCounselingPreAuditOrCheckInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      preAuditOrCheckDetail: {
        api: urls.kUrlCounselingPreAuditOrCheckDetail,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      sendPreAuditOrCheck: {
        api: urls.kUrlCounselingSendPreAuditOrCheck,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      confirmPreAuditOrCheck: {
        api: urls.kUrlCounselingConfirmPreAuditOrCheck,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      updateAuditCheckState: {
        api: urls.kUrlCounselingUpdateAuditCheckState,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      acceptanceResults: {
        api: urls.kUrlCounselingPreAuditOrCheckAcceptanceResults,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      evaluationCriteria: {
        api: urls.kUrlCounselingPreAuditOrCheckEvaluationCriteria,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      updateCriteria: {
        api: urls.kUrlCounselingUpdateCriteria,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      importCriteria: {
        api: urls.kUrlCounselingImportCriteria,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      saveCriteria: {
        api: urls.kUrlCounselingSaveCriteria,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      coachProcessList: {
        api: urls.kUrlCounselingCoachProcessList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      coachProcessSend: {
        api: urls.kUrlCounselingCoachProcessSend,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      confirmCoachProcess: {
        api: urls.kUrlCounselingConfirmCoachProcess,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      // 跟踪
      getTrackTrainingMapList: { // 人员培训
        api: urls.kUrlCounselingGetTrackTrainingMapList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      trackTrainingAdd: { // 人员培训 - 更新
        api: urls.kUrlCounselingTrackTrainingAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      trainingUpdateRemark: { // 人员培训 - 更新备注
        api: urls.kUrlCounselingTrackTrainingUpdate,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      trackTrainingNoticeTargetConfirm: { // 人员培训 - 达标确认
        api: urls.kUrlCounselingTrackTrainingNoticeTargetConfirm,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      getApplyPlanPersonInfoList: { // 人员培训 - 报班情况
        api: urls.kUrlCounselingTrackTrainingGetApplyPlanPersonInfoList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      trackStableList: { // 人员稳定
        api: urls.kUrlCounselingTrackStableList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      trackStableLatestList: { // 人员稳定 - 更新
        api: urls.kUrlCounselingTrackStableLatestList,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      trackStableNoticeTargetConfirm: { // 人员稳定 - 达标确认
        api: urls.kUrlCounselingTrackStableNoticeTargetConfirm,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      getKpiCycleList: { // Kpi
        api: urls.kUrlCounselingTrackKpiCycleGetKpiCycleList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      kpiCycleUpdate: { // Kpi 点评
        api: urls.kUrlCounselingTrackKpiCycleUpdate,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      kpiCycleNoticeTargetConfirm: { // Kpi 达标确认
        api: urls.kUrlCounselingTrackKpiCycleNoticeTargetConfirm,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      // 满意度评估
      satisfactionEvaluationGetList: { // 满意度评估 - 列表
        api: urls.kUrlCounselingTrackSatisfactionEvaluationGetList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      satisfactionEvaluationAdd: { // 满意度评估 - 获取满意度
        api: urls.kUrlCounselingTrackSatisfactionEvaluationAdd,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      satisfactionEvaluationComment: { // 满意度评估 - 点评
        api: urls.kUrlCounselingTrackSatisfactionEvaluationUpdate,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      satisfactionEvaluationNoticeTargetConfirm: { // 满意度评估 - 达标确认
        api: urls.kUrlCounselingTrackSatisfactionEvaluationNoticeTargetConfirm,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      // 摄像头评估
      cameraList: { // 摄像头评估 - 列表
        api: urls.kUrlCounselingTrackCameraList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      cameraObtainCameraAssess: { // 摄像头评估 - 获取摄像头评估
        api: urls.kUrlCounselingTrackCameraObtainCameraAssess,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      cameraLookCheckList: { // 摄像头评估 - 查看/导出
        api: urls.kUrlCounselingTrackCameraLookCheckList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      cameraCheckLookCheckList: { // 摄像头评估 - 点评列表
        api: urls.kUrlCounselingTrackCameraCheckLookCheckList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      cameraCheckSaveCommentCheckList: { // 摄像头评估 - 保存点评
        api: urls.kUrlCounselingTrackCameraCheckSaveCommentCheckList,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      cameraNoticeTargetConfirm: { // 摄像头评估 - 达标确认
        api: urls.kUrlCounselingTrackCameraNoticeTargetConfirm,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      // 满意度评估 Re
      trackSatisfactionPageList: { // 满意度评估 - 列表
        api: urls.kUrlTrackSatisfactionPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      trackCheckSatisfaction: { // 满意度评估 - 新增获取参数
        api: urls.kUrlTrackCheckSatisfaction,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      trackInputTrackSatisfactionMonth: { // 满意度评估 - 新增
        api: urls.kUrlTrackInputTrackSatisfactionMonth,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      trackSatisfactionMonthUpdate: { // 满意度评估 - 编辑
        api: urls.kUrlTrackSatisfactionMonthUpdate,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
      trackSatisfactionMonthDelete: { // 满意度评估 - 删除
        api: urls.kUrlTrackSatisfactionMonthDelete,
        methodType: 'POST',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'processRealTime',
    modelType: 'entity',
    action: {
      updateCriteria: {
        api: urls.kUrlCounselingRealTimeUpdateCriteria,
        methodType: 'PUT',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'syncRelation',
    modelType: 'entity',
    action: {
      positionPageList: {
        api: urls.kUrlSyncRelationPositionPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      positionList: {
        api: urls.kUrlSyncRelationPositionList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      save: {
        api: urls.kUrlSyncRelationSave,
        methodType: 'POST',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'positionChangeRecord',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlPositionChangeRecordPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlPositionChangeRecordList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      reExecute: {
        api: urls.kUrlPositionChangeRecordReExecute,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'changeRecordDetail',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlChangeRecordDetailPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlChangeRecordDetailList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },


  {
    businessName: 'syncEmailConfig',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlSyncEmailConfigPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlSyncEmailConfigList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      save: {
        api: urls.kUrlSyncEmailConfigSave,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      setState: {
        api: urls.kUrlSyncEmailConfigSetState,
        methodType: 'PUT',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },

  {
    businessName: 'requirementPersonnelApply',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlGetRequirementPersonnelApplyList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlGetRequirementPersonnelApplyList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  { //远程认证详情 旧平台
    businessName: 'NevRemoteAuthDetail',
    modelType: 'entity',
    action: {
      batchConfigNevRemoteAuthDetail: {
        api: urls.kUrlBatchConfigNevRemoteAuthDetail,
        methodType: 'POST',
        params: [],
        returnField: {},
      },
    },
    initData: { data: [] }
  },
  {
    businessName: 'verbalTrick',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlVerbalTrickPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlVerbalTrickList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      save: {
        api: urls.kUrlVerbalTrickSave,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      enable: {
        api: urls.kUrlVerbalTrickEnable,
        methodType: 'POST',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'examEveryday',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlExamEverydayResultPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlExamEverydayResultList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      examEverydayPageList: {
        api: urls.kUrlExamEverydayPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      examEverydayList: {
        api: urls.kUrlExamEverydayList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      examEverydayRecordList: {
        api: urls.kUrlExamEverydayRecordList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      examEverydayRecordReport: {
        api: urls.kUrlExamEverydayRecordReport,
        methodType: 'GET',
        returnField: {},
        params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'favorites',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlFavoritesPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlFavoritesList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'notes',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlNotesPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlNotesList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'notesRecord',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlNotesRecordPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlNotesRecordList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'faceAuthLog',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlFaceAuthLogPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlFaceAuthLogList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      selectOne: {
        api: urls.kUrlFaceAuthLogSelectOne,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'examAuthentication',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlExamAuthenticationPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlExamAuthenticationList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      selectOne: {
        api: urls.kUrlExamAuthenticationSelectOne,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      selectOneByExamId: {
        api: urls.kUrlExamPersonAuthByExamId,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'examPersonAuth',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlExamPersonAuthPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlExamPersonAuthList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      selectOne: {
        api: urls.kUrlExamPersonAuthSelectOne,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      selectOneInfo: {
        api: urls.kUrlExamPersonAuthInfo,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      auditResult: {
        api: urls.kUrlExamPersonAuthAuditResult,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      save: {
        api: urls.kUrlExamPersonAuthSave,
        methodType: 'POST',
        returnField: {},
        params: []
      },
      selectOneByExamPaperId: {
        api: urls.kUrlExamPersonAuthByExamPaperId,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'examPersonAuthLog',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlExamPersonAuthLogPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      list: {
        api: urls.kUrlExamPersonAuthLogList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      selectOne: {
        api: urls.kUrlExamPersonAuthLogSelectOne,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },{
    businessName: 'thirdAppSetting',
    modelType: 'entity',
    action: {
      listByPage: {
        api: urls.kUrlThirdAppSettingListByPage,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      add: {
        api: urls.kUrlThirdAppSettingAdd,
        methodType: 'POST',
        returnField: {},
        params: [],
      },
      update: {
        api: urls.kUrlThirdAppSettingUpd,
        methodType: 'PUT',
        returnField: {},
        params: [],
      },
      delete: {
        api: urls.kUrlThirdAppSettingDel,
        methodType: 'DELETE',
        returnField: {},
        params: ['ids'],
      },
      export: {
        api: urls.kUrlThirdAppSettingList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'dealerNewPersonTrain',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlGetDealerNewComerTrainingPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      export: {
        api: urls.kUrlGetDealerNewComerTrainingExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
      updateState: {
        api: urls.kUrlDealerNewComerTrainingUpdateState,
        methodType: 'PUT',
        returnField: {}, params: []
      }
    },
    initData: {}
  },
  {
    businessName: 'requirementOrgPerson',
    modelType: 'entity',
    action: {
      getListByPage: {
        api: urls.kUrlRequirementOrgPersonPageList,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getList: {
        api: urls.kUrlRequirementOrgPersonExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
      // updateState: {
      //   api: urls.kUrlDealerNewComerTrainingUpdateState,
      //   methodType: 'PUT',
      //   returnField: {}, params: []
      // },
      exportRealTrain: {
        api: urls.kUrlRequirementOrgPersonTrainExport,
        methodType: 'GET',
        returnField: {}, params: []
      },
      getInfo: {
        api: urls.kUrlRequirementOrgPersonTrainGetInfo,
        methodType: 'GET',
        returnField: {}, params: []
      },
      dpStateSet: {
        api: urls.kUrlRequirementOrgPersonTrainUpdateStatus,
        methodType: 'POST',
        returnField: {}, params: []
      },
      setOldDealerNewPerson: {
        api: urls.kUrlRequirementOrgPersonTrainUpdateOldOrgNewPerson,
        methodType: 'POST',
        returnField: {}, params: []

      },
    },
    initData: {}
  },
  { // 水印管理
    businessName: 'watermarkManager',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlWatermarkList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlWatermarkAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      upd: {
        api: urls.kUrlWatermarkUpd,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
      enable: {
        api: urls.kUrlWatermarkEnable,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
    },
    initData: {}
  },
  { // 水印
    businessName: 'wizWatermarkInfo',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kurlWatermarkInfo,
        methodType: 'GET',
        returnField: {},
        requestConfig: {},
        params: []
      },
    },
    initData: {}
  },
  {
    //邀请函模版
    businessName: 'inviteLetter',
    modelType: 'entity',
    action: {
      list: {
        api: urls.KUrlInviteLetterList,
        methodType: 'GET',
        returnField: {},
        requestConfig: {},
        params: []
      },
      getById: {
        api: urls.KUrlInviteLetterInfo,
        methodType: 'GET',
        returnField: {},
        requestConfig: {},
        params: []
      },
      add: {
        api: urls.KUrlInviteLetterAdd,
        methodType: 'POST',
        returnField: {},
        requestConfig: {},
        params: []
      },
      update: {
        api: urls.KUrlInviteLetterUpdate,
        methodType: 'PUT',
        returnField: {},
        requestConfig: {},
        params: []
      },
      enable: {
        api: urls.KUrlInviteLetterEnable,
        methodType: 'PUT',
        returnField: {},
        requestConfig: {},
        params: []
      },
    },
    initData: {}
  },
  {
    //邀请函参数
    businessName: 'schemaColumns',
    modelType: 'entity',
    action: {
      columnsInfo: {
        api: urls.KUrlSchemaColumnsInfo,
        methodType: 'GET',
        returnField: {},
        requestConfig: {},
        params: []
      },
      userInfo: {
        api: urls.KUrlSchemaUserColumnInfo,
        methodType: 'GET',
        returnField: {},
        requestConfig: {},
        params: []
      },
    },
    initData: {}
  },
  {
    //报名预警
    businessName: 'applyWarning',
    modelType: 'entity',
    action: {
      listByApplyId: {
        api: urls.kUrlApplyWarningInfo,
        methodType: 'GET',
        returnField: {},
        requestConfig: {},
        params: []
      },
      add: {
        api: urls.kUrlApplyWarningAdd,
        methodType: 'POST',
        returnField: {},
        requestConfig: {},
        params: []
      },
      update: {
        api: urls.kUrlApplyWarningUpdate,
        methodType: 'PUT',
        returnField: {},
        requestConfig: {},
        params: []
      },
    },
    initData: {}
  },
  {
    businessName: 'learningRecord',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlLearningRecordPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlLearningRecordList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },

  { //根据品牌和岗位设置角色和管理权限
    businessName: 'managerPermissionsSetting',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlManagerPermissionsSettingPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlManagerPermissionsSettingAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      update: {
        api: urls.kUrlManagerPermissionsSettingUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
      delete: {
        api: urls.kUrlManagerPermissionsSettingBatchDelete,
        methodType: 'DELETE',
        params: [],
        returnField: {}
      },
      batchUpdateSetting: {
        api: urls.kUrlManagerPermissionsSettingBatchUpdateSetting,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  { //根据品牌和岗位设置角色和管理权限
    businessName: 'syncTimsTransfer',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlSyncTimsTransferPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlSyncTimsTransferAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      update: {
        api: urls.kUrlSyncTimsTransferUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
      delete: {
        api: urls.kUrSyncTimsTransferDelete,
        methodType: 'DELETE',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'userSafe',
    modelType: 'entity',
    action: {
      editPassowrd: {
        api: urls.kUrlEditPassowrd,
        methodType: 'PUT',
        params: [],
        returnField: {},
      },
      sendCode: {
        api: urls.kUrlSendCode,
        methodType: 'POST',
        params: [],
        returnField: {},
        requestConfig: {
          headers: {
            'content-type': 'application/json',
            'auth-key': '822261d4-5f17-4d2f-5e5a8909b27e',
            'endpoint': 'user'
          },
        }
      },
    },
    initData: {}
  },
  {
    businessName: 'userInfo',
    modelType: 'entity',
    action: {
      getUserInfo: {
        api: urls.kUrlUserInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      editUserInfo: {
        api: urls.kUrlEditUserInfo,
        methodType: 'PUT',
        params: [],
        returnField: {},
      }
    },
    initData: {}
  },
  {
    businessName: 'permissionSetting',
    modelType: 'entity',
    action: {
      pageList: {
        api: urls.kUrlPermissionSettingPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      save: {
        api: urls.kUrlPermissionSettingSave,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'accountConsolidationRecord',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlAccountConsolidationRecordPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlAccountConsolidationRecordList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getInfoById: {
        api: urls.kUrlAccountConsolidationRecordById,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlAccountConsolidationRecordAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      audit: {
        api: urls.kUrlAccountConsolidationRecordAudit,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'label',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlLabelPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlLabelList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlLabelAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      update: {
        api: urls.kUrlLabelUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
      delete: {
        api: urls.kUrlLabelDelete,
        methodType: 'DELETE',
        params: [],
        returnField: {}
      },
      addFeatureContent: {
        api: urls.kUrlLabelFeatureContentAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      labelFeatureContent : {
        api: urls.kUrlLabelFeatureContent,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getById: {
        api: urls.kUrlLabelGetById,
        methodType: 'GET',
        params: [],
        returnField: {}
      }
    },
    initData: {}
  },
  {
    businessName: 'labelUser',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlLabelUserPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlLabelUserList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlLabelUserAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      import: {
        api: urls.kUrlLabelUserImport,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'practice',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlPracticePageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlPracticeList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      add: {
        api: urls.kUrlPracticeAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      update: {
        api: urls.kUrlPracticeUpdate,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
      getRuleInfoById: {
        api: urls.kUrlPracticeRuleList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      addRule: {
        api: urls.kUrlPracticeRuleAdd,
        methodType: 'POST',
        params: [],
        returnField: {}
      },
      getBaseInfoById: {
        api: urls.kUrlPracticeInfoById,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      enable: {
        api: urls.kUrlPracticeEnable,
        methodType: 'PUT',
        params: [],
        returnField: {}
      },
      del: {
        api: urls.kUrlPracticeDel,
        methodType: 'DELETE',
        params: [],
        returnField: {}
      },
      findById: {
        api: urls.kUrlPracticeFullInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'practiceRank',
    modelType: 'entity',
    action: {
      dateChartsInfo: {
        api: urls.kUrlPracticeDateChartsInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      chartsInfo: {
        api: urls.kUrlPracticeChartsInfo,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      list: {
        api: urls.kUrlPracticePaperPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlPracticePaperList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      dateList: {
        api: urls.kUrlPracticeDateRankPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      dateExport: {
        api: urls.kUrlPracticeDateRankList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      rankList: {
        api: urls.kUrlPracticeRankPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      rankExport: {
        api: urls.kUrlPracticeRankList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
    },
    initData: {}
  },
  {
    businessName: 'practiceRecord',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlPracticeRecordPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      export: {
        api: urls.kUrlPracticeRecordList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      detailList: {
        api: urls.kUrlPracticeDetailPageList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      detailExport: {
        api: urls.kUrlPracticeDetailList,
        methodType: 'GET',
        params: [],
        returnField: {}
      },
      getDetailByPaperId: {
        api: urls.kUrlPracticePaperDetail,
        methodType: 'GET',
        params: [],
        returnField: {}
      }
    },
    initData: {}
  },
  {
    businessName: 'dimStudentReport',
    modelType: 'entity',
    action: {
      list: {
        api: urls.kUrlDimStudentReportPageList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
      export: {
        api: urls.kUrlDimStudentReportList,
        methodType: 'GET',
        returnField: {},
        params: []
      },
    },
    initData: {}
  },
]
